import { emptySplitApi as api } from "./emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2Admins: build.mutation<PostV2AdminsApiResponse, PostV2AdminsApiArg>({
      query: (queryArg) => ({
        url: `/v2/Admins`,
        method: "POST",
        body: queryArg,
      }),
    }),
    getV2ExamsByExamIdAlcoTestProcsAndId: build.query<
      GetV2ExamsByExamIdAlcoTestProcsAndIdApiResponse,
      GetV2ExamsByExamIdAlcoTestProcsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/AlcoTestProcs/${queryArg.id}`,
      }),
    }),
    postV2ExamsByExamIdAlcoTestProcsStart: build.mutation<
      PostV2ExamsByExamIdAlcoTestProcsStartApiResponse,
      PostV2ExamsByExamIdAlcoTestProcsStartApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg}/AlcoTestProcs/Start`,
        method: "POST",
      }),
    }),
    postV2ExamsByExamIdAlcoTestProcs: build.mutation<
      PostV2ExamsByExamIdAlcoTestProcsApiResponse,
      PostV2ExamsByExamIdAlcoTestProcsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/AlcoTestProcs`,
        method: "POST",
        body: queryArg.addAlcoTestProcRequest,
      }),
    }),
    getV2QuizesByQuizIdAnswers: build.query<
      GetV2QuizesByQuizIdAnswersApiResponse,
      GetV2QuizesByQuizIdAnswersApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Quizes/${queryArg}/Answers` }),
    }),
    getV2QuizesByQuizIdAnswersAndId: build.query<
      GetV2QuizesByQuizIdAnswersAndIdApiResponse,
      GetV2QuizesByQuizIdAnswersAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Quizes/${queryArg.quizId}/Answers/${queryArg.id}`,
      }),
    }),
    postV2QuizesByQuizIdAnswersList: build.mutation<
      PostV2QuizesByQuizIdAnswersListApiResponse,
      PostV2QuizesByQuizIdAnswersListApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Quizes/${queryArg.quizId}/Answers/List`,
        method: "POST",
        body: queryArg.addAnswerListRequest,
      }),
    }),
    getV2TerminalsByTerminalIdApiKeys: build.query<
      GetV2TerminalsByTerminalIdApiKeysApiResponse,
      GetV2TerminalsByTerminalIdApiKeysApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Terminals/${queryArg}/ApiKeys` }),
    }),
    postV2TerminalsByTerminalIdApiKeys: build.mutation<
      PostV2TerminalsByTerminalIdApiKeysApiResponse,
      PostV2TerminalsByTerminalIdApiKeysApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.terminalId}/ApiKeys`,
        method: "POST",
        body: queryArg.addApiKeyRequest,
      }),
    }),
    postAuthenticationLogin: build.mutation<
      PostAuthenticationLoginApiResponse,
      PostAuthenticationLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/Authentication/Login`,
        method: "POST",
        body: queryArg,
      }),
    }),
    postAuthenticationRefreshToken: build.mutation<
      PostAuthenticationRefreshTokenApiResponse,
      PostAuthenticationRefreshTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/Authentication/RefreshToken`,
        method: "POST",
        body: queryArg,
      }),
    }),
    getV2ExamsByExamIdBloodPressProcsAndId: build.query<
      GetV2ExamsByExamIdBloodPressProcsAndIdApiResponse,
      GetV2ExamsByExamIdBloodPressProcsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/BloodPressProcs/${queryArg.id}`,
      }),
    }),
    postV2ExamsByExamIdBloodPressProcsStart: build.mutation<
      PostV2ExamsByExamIdBloodPressProcsStartApiResponse,
      PostV2ExamsByExamIdBloodPressProcsStartApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg}/BloodPressProcs/Start`,
        method: "POST",
      }),
    }),
    postV2ExamsByExamIdBloodPressProcs: build.mutation<
      PostV2ExamsByExamIdBloodPressProcsApiResponse,
      PostV2ExamsByExamIdBloodPressProcsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/BloodPressProcs`,
        method: "POST",
        body: queryArg.addBloodPressProcRequest,
      }),
    }),
    getV2PersonsByPersonIdCertificates: build.query<
      GetV2PersonsByPersonIdCertificatesApiResponse,
      GetV2PersonsByPersonIdCertificatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Certificates`,
        params: {
          isActive: queryArg.isActive,
        },
      }),
    }),
    postV2PersonsByPersonIdCertificates: build.mutation<
      PostV2PersonsByPersonIdCertificatesApiResponse,
      PostV2PersonsByPersonIdCertificatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Certificates`,
        method: "POST",
        body: queryArg.addCertificateRequest,
      }),
    }),
    putV2PersonsByPersonIdCertificatesAndIdStatus: build.mutation<
      PutV2PersonsByPersonIdCertificatesAndIdStatusApiResponse,
      PutV2PersonsByPersonIdCertificatesAndIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Certificates/${queryArg.id}/Status`,
        method: "PUT",
        params: {
          isActive: queryArg.isActive,
        },
      }),
    }),
    getV2ExamsByExamIdConclusions: build.query<
      GetV2ExamsByExamIdConclusionsApiResponse,
      GetV2ExamsByExamIdConclusionsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Exams/${queryArg}/Conclusions` }),
    }),
    postV2ExamsByExamIdConclusions: build.mutation<
      PostV2ExamsByExamIdConclusionsApiResponse,
      PostV2ExamsByExamIdConclusionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/Conclusions`,
        method: "POST",
        body: queryArg.addConclusionRequest,
      }),
    }),
    getV2ExamsConclusionsStatistics: build.query<
      GetV2ExamsConclusionsStatisticsApiResponse,
      GetV2ExamsConclusionsStatisticsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/Conclusions/Statistics`,
        params: {
          minStartDate: queryArg,
        },
      }),
    }),
    getV2PatientsByPatientIdExamsConclusions: build.query<
      GetV2PatientsByPatientIdExamsConclusionsApiResponse,
      GetV2PatientsByPatientIdExamsConclusionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Patients/${queryArg.patientId}/Exams/Conclusions`,
        params: {
          since: queryArg.since,
        },
      }),
    }),
    getV2ConclusionsByIdSticker: build.query<
      GetV2ConclusionsByIdStickerApiResponse,
      GetV2ConclusionsByIdStickerApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Conclusions/${queryArg}/Sticker` }),
    }),
    postV2ExamsByExamIdConclusionsAndIdGenerateDocument: build.mutation<
      PostV2ExamsByExamIdConclusionsAndIdGenerateDocumentApiResponse,
      PostV2ExamsByExamIdConclusionsAndIdGenerateDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/Conclusions/${queryArg.id}/GenerateDocument`,
        method: "POST",
      }),
    }),
    postV2ExamsByExamIdConclusionsAndIdSign: build.mutation<
      PostV2ExamsByExamIdConclusionsAndIdSignApiResponse,
      PostV2ExamsByExamIdConclusionsAndIdSignApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/Conclusions/${queryArg.id}/Sign`,
        method: "POST",
        body: queryArg.body,
        params: {
          certificateId: queryArg.certificateId,
        },
      }),
    }),
    postV2Directors: build.mutation<
      PostV2DirectorsApiResponse,
      PostV2DirectorsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Directors`,
        method: "POST",
        body: queryArg,
      }),
    }),
    getV2PersonsByPersonIdDoctors: build.query<
      GetV2PersonsByPersonIdDoctorsApiResponse,
      GetV2PersonsByPersonIdDoctorsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Persons/${queryArg}/Doctors` }),
    }),
    getV2MedOrganizationsByMedOrganizationIdDoctors: build.query<
      GetV2MedOrganizationsByMedOrganizationIdDoctorsApiResponse,
      GetV2MedOrganizationsByMedOrganizationIdDoctorsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/MedOrganizations/${queryArg}/Doctors`,
      }),
    }),
    postV2Doctors: build.mutation<
      PostV2DoctorsApiResponse,
      PostV2DoctorsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Doctors`,
        method: "POST",
        body: queryArg,
      }),
    }),
    putV2PersonsByPersonIdDoctorsAndId: build.mutation<
      PutV2PersonsByPersonIdDoctorsAndIdApiResponse,
      PutV2PersonsByPersonIdDoctorsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Doctors/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changeDoctorRequest,
      }),
    }),
    putV2PatientsByPatientIdDriverLicensesAndId: build.mutation<
      PutV2PatientsByPatientIdDriverLicensesAndIdApiResponse,
      PutV2PatientsByPatientIdDriverLicensesAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Patients/${queryArg.patientId}/DriverLicenses/${queryArg.id}`,
        method: "PUT",
        body: queryArg.driverLicenseDto,
      }),
    }),
    deleteV2PatientsByPatientIdDriverLicensesAndId: build.mutation<
      DeleteV2PatientsByPatientIdDriverLicensesAndIdApiResponse,
      DeleteV2PatientsByPatientIdDriverLicensesAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Patients/${queryArg.patientId}/DriverLicenses/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getV2DoctorsByDoctorIdEducations: build.query<
      GetV2DoctorsByDoctorIdEducationsApiResponse,
      GetV2DoctorsByDoctorIdEducationsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Doctors/${queryArg}/Educations` }),
    }),
    postV2DoctorsByDoctorIdEducations: build.mutation<
      PostV2DoctorsByDoctorIdEducationsApiResponse,
      PostV2DoctorsByDoctorIdEducationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Doctors/${queryArg.doctorId}/Educations`,
        method: "POST",
        body: queryArg.addEducationRequest,
      }),
    }),
    putV2DoctorsByDoctorIdEducationsAndId: build.mutation<
      PutV2DoctorsByDoctorIdEducationsAndIdApiResponse,
      PutV2DoctorsByDoctorIdEducationsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Doctors/${queryArg.doctorId}/Educations/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changeEducationRequest,
      }),
    }),
    deleteV2DoctorsByDoctorIdEducationsAndId: build.mutation<
      DeleteV2DoctorsByDoctorIdEducationsAndIdApiResponse,
      DeleteV2DoctorsByDoctorIdEducationsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Doctors/${queryArg.doctorId}/Educations/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    postV2ExamsByExamIdMediasProcedurePhoto: build.mutation<
      PostV2ExamsByExamIdMediasProcedurePhotoApiResponse,
      PostV2ExamsByExamIdMediasProcedurePhotoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/Medias/ProcedurePhoto`,
        method: "POST",
        body: queryArg.body,
        params: {
          stage: queryArg.stage,
        },
      }),
    }),
    postV2ExamsByExamIdMediasVideo: build.mutation<
      PostV2ExamsByExamIdMediasVideoApiResponse,
      PostV2ExamsByExamIdMediasVideoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/Medias/Video`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getV2Exams: build.query<GetV2ExamsApiResponse, GetV2ExamsApiArg>({
      query: (queryArg) => ({
        url: `/v2/Exams`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          searchInfo: queryArg.searchInfo,
          sort: queryArg.sort,
          statuses: queryArg.statuses,
          isAdmitted: queryArg.isAdmitted,
          isToday: queryArg.isToday,
          organizationIds: queryArg.organizationIds,
          terminalIds: queryArg.terminalIds,
        },
      }),
    }),
    getV2ExamsById: build.query<
      GetV2ExamsByIdApiResponse,
      GetV2ExamsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Exams/${queryArg}` }),
    }),
    getV2PatientsByPatientIdExams: build.query<
      GetV2PatientsByPatientIdExamsApiResponse,
      GetV2PatientsByPatientIdExamsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Patients/${queryArg.patientId}/Exams`,
        params: {
          lastId: queryArg.lastId,
          filter: queryArg.filter,
          minStartDate: queryArg.minStartDate,
        },
      }),
    }),
    getV2PatientsByPatientIdExamsAvailableTypes: build.query<
      GetV2PatientsByPatientIdExamsAvailableTypesApiResponse,
      GetV2PatientsByPatientIdExamsAvailableTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Patients/${queryArg}/Exams/AvailableTypes`,
      }),
    }),
    postV2ExamsStart: build.mutation<
      PostV2ExamsStartApiResponse,
      PostV2ExamsStartApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/Start`,
        method: "POST",
        body: queryArg,
      }),
    }),
    postV2ExamsByIdBreak: build.mutation<
      PostV2ExamsByIdBreakApiResponse,
      PostV2ExamsByIdBreakApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.id}/Break`,
        method: "POST",
        params: {
          failReason: queryArg.failReason,
        },
      }),
    }),
    putV2ExamsByIdStatus: build.mutation<
      PutV2ExamsByIdStatusApiResponse,
      PutV2ExamsByIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.id}/Status`,
        method: "PUT",
        params: {
          statusType: queryArg.statusType,
        },
      }),
    }),
    postV2ExternalDoctors: build.mutation<
      PostV2ExternalDoctorsApiResponse,
      PostV2ExternalDoctorsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/ExternalDoctors`,
        method: "POST",
        body: queryArg,
      }),
    }),
    getV2FaceVerificationResultsEvents: build.query<
      GetV2FaceVerificationResultsEventsApiResponse,
      GetV2FaceVerificationResultsEventsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/FaceVerificationResults/Events`,
        params: {
          examId: queryArg,
        },
      }),
    }),
    getV2FilesDownloadUrl: build.query<
      GetV2FilesDownloadUrlApiResponse,
      GetV2FilesDownloadUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Files/DownloadUrl`,
        params: {
          fileType: queryArg.fileType,
          key: queryArg.key,
        },
      }),
    }),
    postV2FilesOtherUpload: build.mutation<
      PostV2FilesOtherUploadApiResponse,
      PostV2FilesOtherUploadApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Files/Other/Upload`,
        method: "POST",
        body: queryArg,
      }),
    }),
    postV2LicenseData: build.mutation<
      PostV2LicenseDataApiResponse,
      PostV2LicenseDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/License/Data`,
        method: "POST",
        body: queryArg,
      }),
    }),
    postV2TerminalsByTerminalIdLuxmeterData: build.mutation<
      PostV2TerminalsByTerminalIdLuxmeterDataApiResponse,
      PostV2TerminalsByTerminalIdLuxmeterDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.terminalId}/LuxmeterData`,
        method: "POST",
        body: queryArg.addLuxmeterDataRequest,
      }),
    }),
    getV2TerminalsByTerminalIdLuxmeterData: build.query<
      GetV2TerminalsByTerminalIdLuxmeterDataApiResponse,
      GetV2TerminalsByTerminalIdLuxmeterDataApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Terminals/${queryArg}/LuxmeterData` }),
    }),
    getV2TerminalsByTerminalIdLuxmeterDataClosest: build.query<
      GetV2TerminalsByTerminalIdLuxmeterDataClosestApiResponse,
      GetV2TerminalsByTerminalIdLuxmeterDataClosestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.terminalId}/LuxmeterData/Closest`,
        params: {
          dateTime: queryArg.dateTime,
        },
      }),
    }),
    getV2MedOrganizations: build.query<
      GetV2MedOrganizationsApiResponse,
      GetV2MedOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/MedOrganizations`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          searchInfo: queryArg.searchInfo,
          sort: queryArg.sort,
        },
      }),
    }),
    postV2MedOrganizations: build.mutation<
      PostV2MedOrganizationsApiResponse,
      PostV2MedOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/MedOrganizations`,
        method: "POST",
        body: queryArg,
      }),
    }),
    getV2MedOrganizationsById: build.query<
      GetV2MedOrganizationsByIdApiResponse,
      GetV2MedOrganizationsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/MedOrganizations/${queryArg}` }),
    }),
    putV2MedOrganizationsById: build.mutation<
      PutV2MedOrganizationsByIdApiResponse,
      PutV2MedOrganizationsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/MedOrganizations/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changeMedOrganizationRequest,
      }),
    }),
    deleteV2MedOrganizationsById: build.mutation<
      DeleteV2MedOrganizationsByIdApiResponse,
      DeleteV2MedOrganizationsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/MedOrganizations/${queryArg}`,
        method: "DELETE",
      }),
    }),
    getV2OrganizationsByOrganizationIdMedOrganizations: build.query<
      GetV2OrganizationsByOrganizationIdMedOrganizationsApiResponse,
      GetV2OrganizationsByOrganizationIdMedOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Organizations/${queryArg}/MedOrganizations`,
      }),
    }),
    getV2ExamsByExamIdMindTestsAndId: build.query<
      GetV2ExamsByExamIdMindTestsAndIdApiResponse,
      GetV2ExamsByExamIdMindTestsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/MindTests/${queryArg.id}`,
      }),
    }),
    postV2ExamsByExamIdMindTests: build.mutation<
      PostV2ExamsByExamIdMindTestsApiResponse,
      PostV2ExamsByExamIdMindTestsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/MindTests`,
        method: "POST",
        body: queryArg.addMindTestRequest,
      }),
    }),
    getV2PersonsByPersonIdNotifications: build.query<
      GetV2PersonsByPersonIdNotificationsApiResponse,
      GetV2PersonsByPersonIdNotificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Notifications`,
        params: {
          isRead: queryArg.isRead,
          types: queryArg.types,
          page: queryArg.page,
          offset: queryArg.offset,
          sort: queryArg.sort,
        },
      }),
    }),
    deleteV2PersonsByPersonIdNotifications: build.mutation<
      DeleteV2PersonsByPersonIdNotificationsApiResponse,
      DeleteV2PersonsByPersonIdNotificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg}/Notifications`,
        method: "DELETE",
      }),
    }),
    putV2PersonsByPersonIdNotificationsAndIdRead: build.mutation<
      PutV2PersonsByPersonIdNotificationsAndIdReadApiResponse,
      PutV2PersonsByPersonIdNotificationsAndIdReadApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Notifications/${queryArg.id}/Read`,
        method: "PUT",
      }),
    }),
    putV2PersonsByPersonIdNotificationsRead: build.mutation<
      PutV2PersonsByPersonIdNotificationsReadApiResponse,
      PutV2PersonsByPersonIdNotificationsReadApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg}/Notifications/Read`,
        method: "PUT",
      }),
    }),
    deleteV2PersonsByPersonIdNotificationsAndId: build.mutation<
      DeleteV2PersonsByPersonIdNotificationsAndIdApiResponse,
      DeleteV2PersonsByPersonIdNotificationsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Notifications/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    putV2PersonsByPersonIdNotificationsToken: build.mutation<
      PutV2PersonsByPersonIdNotificationsTokenApiResponse,
      PutV2PersonsByPersonIdNotificationsTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Notifications/Token`,
        method: "PUT",
        params: {
          notificationToken: queryArg.notificationToken,
        },
      }),
    }),
    getV2Organizations: build.query<
      GetV2OrganizationsApiResponse,
      GetV2OrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Organizations`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          searchInfo: queryArg.searchInfo,
          sort: queryArg.sort,
        },
      }),
    }),
    postV2Organizations: build.mutation<
      PostV2OrganizationsApiResponse,
      PostV2OrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Organizations`,
        method: "POST",
        body: queryArg,
      }),
    }),
    getV2OrganizationsById: build.query<
      GetV2OrganizationsByIdApiResponse,
      GetV2OrganizationsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Organizations/${queryArg}` }),
    }),
    putV2OrganizationsById: build.mutation<
      PutV2OrganizationsByIdApiResponse,
      PutV2OrganizationsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Organizations/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changeOrganizationRequest,
      }),
    }),
    deleteV2OrganizationsById: build.mutation<
      DeleteV2OrganizationsByIdApiResponse,
      DeleteV2OrganizationsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Organizations/${queryArg}`,
        method: "DELETE",
      }),
    }),
    getV2MedOrganizationsByMedOrganizationIdOrganizations: build.query<
      GetV2MedOrganizationsByMedOrganizationIdOrganizationsApiResponse,
      GetV2MedOrganizationsByMedOrganizationIdOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/MedOrganizations/${queryArg}/Organizations`,
      }),
    }),
    postV2OrganizationsByIdMedOrganizationsAndMedOrganizationId: build.mutation<
      PostV2OrganizationsByIdMedOrganizationsAndMedOrganizationIdApiResponse,
      PostV2OrganizationsByIdMedOrganizationsAndMedOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Organizations/${queryArg.id}/MedOrganizations/${queryArg.medOrganizationId}`,
        method: "POST",
      }),
    }),
    deleteV2OrganizationsByIdMedOrganizationsAndMedOrganizationId:
      build.mutation<
        DeleteV2OrganizationsByIdMedOrganizationsAndMedOrganizationIdApiResponse,
        DeleteV2OrganizationsByIdMedOrganizationsAndMedOrganizationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Organizations/${queryArg.id}/MedOrganizations/${queryArg.medOrganizationId}`,
          method: "DELETE",
        }),
      }),
    getV2PersonsByPersonalNumberByPersonalNumberPatients: build.query<
      GetV2PersonsByPersonalNumberByPersonalNumberPatientsApiResponse,
      GetV2PersonsByPersonalNumberByPersonalNumberPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/ByPersonalNumber/${queryArg}/Patients`,
      }),
    }),
    getV2PersonsBySnilsBySnilsPatients: build.query<
      GetV2PersonsBySnilsBySnilsPatientsApiResponse,
      GetV2PersonsBySnilsBySnilsPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/BySnils/${queryArg}/Patients`,
      }),
    }),
    getV2PersonsByPersonIdPatients: build.query<
      GetV2PersonsByPersonIdPatientsApiResponse,
      GetV2PersonsByPersonIdPatientsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Persons/${queryArg}/Patients` }),
    }),
    getV2OrganizationsByOrganizationIdPatients: build.query<
      GetV2OrganizationsByOrganizationIdPatientsApiResponse,
      GetV2OrganizationsByOrganizationIdPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Organizations/${queryArg.organizationId}/Patients`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          sort: queryArg.sort,
        },
      }),
    }),
    getV2PatientsByExternalIdByExternalId: build.query<
      GetV2PatientsByExternalIdByExternalIdApiResponse,
      GetV2PatientsByExternalIdByExternalIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Patients/ByExternalId/${queryArg}` }),
    }),
    postV2Patients: build.mutation<
      PostV2PatientsApiResponse,
      PostV2PatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Patients`,
        method: "POST",
        body: queryArg,
      }),
    }),
    putV2PersonsByPersonIdPatientsAndId: build.mutation<
      PutV2PersonsByPersonIdPatientsAndIdApiResponse,
      PutV2PersonsByPersonIdPatientsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Patients/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changePatientRequest,
      }),
    }),
    putV2PersonsByPersonIdPatientsAndIdActivity: build.mutation<
      PutV2PersonsByPersonIdPatientsAndIdActivityApiResponse,
      PutV2PersonsByPersonIdPatientsAndIdActivityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Patients/${queryArg.id}/Activity`,
        method: "PUT",
        params: {
          isActive: queryArg.isActive,
        },
      }),
    }),
    getV2PersonsByPersonIdPhotos: build.query<
      GetV2PersonsByPersonIdPhotosApiResponse,
      GetV2PersonsByPersonIdPhotosApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Persons/${queryArg}/Photos` }),
    }),
    postV2PersonsByPersonIdPhotos: build.mutation<
      PostV2PersonsByPersonIdPhotosApiResponse,
      PostV2PersonsByPersonIdPhotosApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Photos`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putV2PersonsByPersonIdPhotosAndId: build.mutation<
      PutV2PersonsByPersonIdPhotosAndIdApiResponse,
      PutV2PersonsByPersonIdPhotosAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Photos/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changePersonPhotoRequest,
      }),
    }),
    deleteV2PersonsByPersonIdPhotosAndId: build.mutation<
      DeleteV2PersonsByPersonIdPhotosAndIdApiResponse,
      DeleteV2PersonsByPersonIdPhotosAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Photos/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    putV2PersonsByPersonIdPhotosStatus: build.mutation<
      PutV2PersonsByPersonIdPhotosStatusApiResponse,
      PutV2PersonsByPersonIdPhotosStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.personId}/Photos/Status`,
        method: "PUT",
        params: {
          status: queryArg.status,
        },
      }),
    }),
    getV2Persons: build.query<GetV2PersonsApiResponse, GetV2PersonsApiArg>({
      query: (queryArg) => ({
        url: `/v2/Persons`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          sort: queryArg.sort,
          searchInfo: queryArg.searchInfo,
          roleNames: queryArg.roleNames,
          userStatus: queryArg.userStatus,
        },
      }),
    }),
    getV2PersonsById: build.query<
      GetV2PersonsByIdApiResponse,
      GetV2PersonsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Persons/${queryArg}` }),
    }),
    putV2PersonsById: build.mutation<
      PutV2PersonsByIdApiResponse,
      PutV2PersonsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changePersonRequest,
      }),
    }),
    getV2PersonsPersonalNumberByPersonalNumberIsUnique: build.query<
      GetV2PersonsPersonalNumberByPersonalNumberIsUniqueApiResponse,
      GetV2PersonsPersonalNumberByPersonalNumberIsUniqueApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Persons/PersonalNumber/${queryArg}/IsUnique`,
      }),
    }),
    getV2PersonsSnilsBySnilsIsUnique: build.query<
      GetV2PersonsSnilsBySnilsIsUniqueApiResponse,
      GetV2PersonsSnilsBySnilsIsUniqueApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Persons/Snils/${queryArg}/IsUnique` }),
    }),
    getV2PostTripJournals: build.query<
      GetV2PostTripJournalsApiResponse,
      GetV2PostTripJournalsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/PostTripJournals`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          sortOrder: queryArg.sortOrder,
          date: queryArg.date,
          timezone: queryArg.timezone,
        },
      }),
    }),
    getV2PostTripJournalsById: build.query<
      GetV2PostTripJournalsByIdApiResponse,
      GetV2PostTripJournalsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/PostTripJournals/${queryArg}` }),
    }),
    getV2PostTripJournalsDates: build.query<
      GetV2PostTripJournalsDatesApiResponse,
      GetV2PostTripJournalsDatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/PostTripJournals/Dates`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          timezone: queryArg.timezone,
          sortOrder: queryArg.sortOrder,
          dateFrom: queryArg.dateFrom,
          dateTo: queryArg.dateTo,
        },
      }),
    }),
    getV2PostTripJournalsDocument: build.query<
      GetV2PostTripJournalsDocumentApiResponse,
      GetV2PostTripJournalsDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/PostTripJournals/Document`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          fileExtension: queryArg.fileExtension,
        },
      }),
    }),
    postV2PostTripJournalsByIdSign: build.mutation<
      PostV2PostTripJournalsByIdSignApiResponse,
      PostV2PostTripJournalsByIdSignApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/PostTripJournals/${queryArg.id}/Sign`,
        method: "POST",
        body: queryArg.signJournalRequest,
      }),
    }),
    postV2ExamsByExamIdPostTripJournalsSign: build.mutation<
      PostV2ExamsByExamIdPostTripJournalsSignApiResponse,
      PostV2ExamsByExamIdPostTripJournalsSignApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/PostTripJournals/Sign`,
        method: "POST",
        body: queryArg.signJournalRequest,
      }),
    }),
    getV2ExamsByExamIdPostTripJournalsHash: build.query<
      GetV2ExamsByExamIdPostTripJournalsHashApiResponse,
      GetV2ExamsByExamIdPostTripJournalsHashApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg}/PostTripJournals/Hash`,
      }),
    }),
    getV2PostTripJournalsByIdHash: build.query<
      GetV2PostTripJournalsByIdHashApiResponse,
      GetV2PostTripJournalsByIdHashApiArg
    >({
      query: (queryArg) => ({ url: `/v2/PostTripJournals/${queryArg}/Hash` }),
    }),
    getV2PreTripJournals: build.query<
      GetV2PreTripJournalsApiResponse,
      GetV2PreTripJournalsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/PreTripJournals`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          sortOrder: queryArg.sortOrder,
          date: queryArg.date,
          timezone: queryArg.timezone,
        },
      }),
    }),
    getV2PreTripJournalsById: build.query<
      GetV2PreTripJournalsByIdApiResponse,
      GetV2PreTripJournalsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/PreTripJournals/${queryArg}` }),
    }),
    getV2PreTripJournalsDates: build.query<
      GetV2PreTripJournalsDatesApiResponse,
      GetV2PreTripJournalsDatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/PreTripJournals/Dates`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          timezone: queryArg.timezone,
          sortOrder: queryArg.sortOrder,
          dateFrom: queryArg.dateFrom,
          dateTo: queryArg.dateTo,
        },
      }),
    }),
    getV2PreTripJournalsDocument: build.query<
      GetV2PreTripJournalsDocumentApiResponse,
      GetV2PreTripJournalsDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/PreTripJournals/Document`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          fileExtension: queryArg.fileExtension,
        },
      }),
    }),
    postV2PreTripJournalsByIdSign: build.mutation<
      PostV2PreTripJournalsByIdSignApiResponse,
      PostV2PreTripJournalsByIdSignApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/PreTripJournals/${queryArg.id}/Sign`,
        method: "POST",
        body: queryArg.signJournalRequest,
      }),
    }),
    postV2ExamsByExamIdPreTripJournalsSign: build.mutation<
      PostV2ExamsByExamIdPreTripJournalsSignApiResponse,
      PostV2ExamsByExamIdPreTripJournalsSignApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/PreTripJournals/Sign`,
        method: "POST",
        body: queryArg.signJournalRequest,
      }),
    }),
    getV2ExamsByExamIdPreTripJournalsHash: build.query<
      GetV2ExamsByExamIdPreTripJournalsHashApiResponse,
      GetV2ExamsByExamIdPreTripJournalsHashApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg}/PreTripJournals/Hash`,
      }),
    }),
    getV2PreTripJournalsByIdHash: build.query<
      GetV2PreTripJournalsByIdHashApiResponse,
      GetV2PreTripJournalsByIdHashApiArg
    >({
      query: (queryArg) => ({ url: `/v2/PreTripJournals/${queryArg}/Hash` }),
    }),
    getV2ProcedureDevices: build.query<
      GetV2ProcedureDevicesApiResponse,
      GetV2ProcedureDevicesApiArg
    >({
      query: () => ({ url: `/v2/ProcedureDevices` }),
    }),
    getV2ProcedureDevicesByNameByName: build.query<
      GetV2ProcedureDevicesByNameByNameApiResponse,
      GetV2ProcedureDevicesByNameByNameApiArg
    >({
      query: (queryArg) => ({ url: `/v2/ProcedureDevices/ByName/${queryArg}` }),
    }),
    putV2ProcedureDevicesById: build.mutation<
      PutV2ProcedureDevicesByIdApiResponse,
      PutV2ProcedureDevicesByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/ProcedureDevices/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changeProcedureDeviceRequest,
      }),
    }),
    getV2Questions: build.query<
      GetV2QuestionsApiResponse,
      GetV2QuestionsApiArg
    >({
      query: () => ({ url: `/v2/Questions` }),
    }),
    postV2ExamsByExamIdQuizes: build.mutation<
      PostV2ExamsByExamIdQuizesApiResponse,
      PostV2ExamsByExamIdQuizesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/Quizes`,
        method: "POST",
        body: queryArg.addQuizRequest,
      }),
    }),
    getV2Reasons: build.query<GetV2ReasonsApiResponse, GetV2ReasonsApiArg>({
      query: () => ({ url: `/v2/Reasons` }),
    }),
    getV2ReasonsById: build.query<
      GetV2ReasonsByIdApiResponse,
      GetV2ReasonsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Reasons/${queryArg}` }),
    }),
    getV2PatientsByPatientIdReferenceIndicators: build.query<
      GetV2PatientsByPatientIdReferenceIndicatorsApiResponse,
      GetV2PatientsByPatientIdReferenceIndicatorsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Patients/${queryArg}/ReferenceIndicators`,
      }),
    }),
    postV2PatientsByPatientIdReferenceIndicators: build.mutation<
      PostV2PatientsByPatientIdReferenceIndicatorsApiResponse,
      PostV2PatientsByPatientIdReferenceIndicatorsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Patients/${queryArg.patientId}/ReferenceIndicators`,
        method: "POST",
        body: queryArg.addReferenceIndicatorRequest,
      }),
    }),
    putV2PatientsByPatientIdReferenceIndicatorsAndId: build.mutation<
      PutV2PatientsByPatientIdReferenceIndicatorsAndIdApiResponse,
      PutV2PatientsByPatientIdReferenceIndicatorsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Patients/${queryArg.patientId}/ReferenceIndicators/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changeReferenceIndicatorRequest,
      }),
    }),
    deleteV2PatientsByPatientIdReferenceIndicatorsAndId: build.mutation<
      DeleteV2PatientsByPatientIdReferenceIndicatorsAndIdApiResponse,
      DeleteV2PatientsByPatientIdReferenceIndicatorsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Patients/${queryArg.patientId}/ReferenceIndicators/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getV2ReportsGeneratePivotTable: build.query<
      GetV2ReportsGeneratePivotTableApiResponse,
      GetV2ReportsGeneratePivotTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Reports/GeneratePivotTable`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    getV2ReportsGenerateExamReport: build.query<
      GetV2ReportsGenerateExamReportApiResponse,
      GetV2ReportsGenerateExamReportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Reports/GenerateExamReport`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    getV2Roles: build.query<GetV2RolesApiResponse, GetV2RolesApiArg>({
      query: () => ({ url: `/v2/Roles` }),
    }),
    getV2UsersByUserIdRoles: build.query<
      GetV2UsersByUserIdRolesApiResponse,
      GetV2UsersByUserIdRolesApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Users/${queryArg}/Roles` }),
    }),
    postV2UsersByUserIdRolesAdmin: build.mutation<
      PostV2UsersByUserIdRolesAdminApiResponse,
      PostV2UsersByUserIdRolesAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Users/${queryArg}/Roles/Admin`,
        method: "POST",
      }),
    }),
    postV2UsersByUserIdRolesDirector: build.mutation<
      PostV2UsersByUserIdRolesDirectorApiResponse,
      PostV2UsersByUserIdRolesDirectorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Users/${queryArg}/Roles/Director`,
        method: "POST",
      }),
    }),
    postV2UsersByUserIdRolesDoctor: build.mutation<
      PostV2UsersByUserIdRolesDoctorApiResponse,
      PostV2UsersByUserIdRolesDoctorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Users/${queryArg.userId}/Roles/Doctor`,
        method: "POST",
        body: queryArg.assignDoctorRoleRequest,
      }),
    }),
    deleteV2UsersByUserIdRolesAndId: build.mutation<
      DeleteV2UsersByUserIdRolesAndIdApiResponse,
      DeleteV2UsersByUserIdRolesAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Users/${queryArg.userId}/Roles/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getV2ExamsSetSseConnection: build.query<
      GetV2ExamsSetSseConnectionApiResponse,
      GetV2ExamsSetSseConnectionApiArg
    >({
      query: () => ({ url: `/v2/Exams/SetSSEConnection` }),
    }),
    getV2Specialities: build.query<
      GetV2SpecialitiesApiResponse,
      GetV2SpecialitiesApiArg
    >({
      query: () => ({ url: `/v2/Specialities` }),
    }),
    getV2ExamsByExamIdSpeechTestsAndId: build.query<
      GetV2ExamsByExamIdSpeechTestsAndIdApiResponse,
      GetV2ExamsByExamIdSpeechTestsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/SpeechTests/${queryArg.id}`,
      }),
    }),
    postV2ExamsByExamIdSpeechTests: build.mutation<
      PostV2ExamsByExamIdSpeechTestsApiResponse,
      PostV2ExamsByExamIdSpeechTestsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/SpeechTests`,
        method: "POST",
        body: queryArg.body,
        params: {
          durationSec: queryArg.durationSec,
        },
      }),
    }),
    getSystemRabbitInfo: build.query<
      GetSystemRabbitInfoApiResponse,
      GetSystemRabbitInfoApiArg
    >({
      query: () => ({ url: `/System/RabbitInfo` }),
    }),
    getSystemApiVersions: build.query<
      GetSystemApiVersionsApiResponse,
      GetSystemApiVersionsApiArg
    >({
      query: () => ({ url: `/System/ApiVersions` }),
    }),
    getSystemClientsVersions: build.query<
      GetSystemClientsVersionsApiResponse,
      GetSystemClientsVersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/System/ClientsVersions`,
        params: {
          platform: queryArg,
        },
      }),
    }),
    getV2ExamsByExamIdTemperatureProcsAndId: build.query<
      GetV2ExamsByExamIdTemperatureProcsAndIdApiResponse,
      GetV2ExamsByExamIdTemperatureProcsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/TemperatureProcs/${queryArg.id}`,
      }),
    }),
    postV2ExamsByExamIdTemperatureProcsStart: build.mutation<
      PostV2ExamsByExamIdTemperatureProcsStartApiResponse,
      PostV2ExamsByExamIdTemperatureProcsStartApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg}/TemperatureProcs/Start`,
        method: "POST",
      }),
    }),
    postV2ExamsByExamIdTemperatureProcs: build.mutation<
      PostV2ExamsByExamIdTemperatureProcsApiResponse,
      PostV2ExamsByExamIdTemperatureProcsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Exams/${queryArg.examId}/TemperatureProcs`,
        method: "POST",
        body: queryArg.addTemperatureProcRequest,
      }),
    }),
    getV2TerminalsByTerminalIdCaseOpenings: build.query<
      GetV2TerminalsByTerminalIdCaseOpeningsApiResponse,
      GetV2TerminalsByTerminalIdCaseOpeningsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Terminals/${queryArg}/CaseOpenings` }),
    }),
    putV2TerminalsByTerminalIdCaseOpeningsIncrement: build.mutation<
      PutV2TerminalsByTerminalIdCaseOpeningsIncrementApiResponse,
      PutV2TerminalsByTerminalIdCaseOpeningsIncrementApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg}/CaseOpenings/Increment`,
        method: "PUT",
      }),
    }),
    postV2TerminalsByTerminalIdChecksums: build.mutation<
      PostV2TerminalsByTerminalIdChecksumsApiResponse,
      PostV2TerminalsByTerminalIdChecksumsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.terminalId}/Checksums`,
        method: "POST",
        body: queryArg.addTerminalChecksumRequest,
      }),
    }),
    putV2TerminalsByTerminalIdChecksumsAndId: build.mutation<
      PutV2TerminalsByTerminalIdChecksumsAndIdApiResponse,
      PutV2TerminalsByTerminalIdChecksumsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.terminalId}/Checksums/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changeTerminalChecksumRequest,
      }),
    }),
    deleteV2TerminalsByTerminalIdChecksumsAndId: build.mutation<
      DeleteV2TerminalsByTerminalIdChecksumsAndIdApiResponse,
      DeleteV2TerminalsByTerminalIdChecksumsAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.terminalId}/Checksums/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getV2TerminalsByTerminalIdEvents: build.query<
      GetV2TerminalsByTerminalIdEventsApiResponse,
      GetV2TerminalsByTerminalIdEventsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.terminalId}/Events`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          sort: queryArg.sort,
        },
      }),
    }),
    postV2TerminalsByTerminalIdEvents: build.mutation<
      PostV2TerminalsByTerminalIdEventsApiResponse,
      PostV2TerminalsByTerminalIdEventsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.terminalId}/Events`,
        method: "POST",
        body: queryArg.addTerminalEventRequest,
      }),
    }),
    getV2Terminals: build.query<
      GetV2TerminalsApiResponse,
      GetV2TerminalsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          sort: queryArg.sort,
          searchInfo: queryArg.searchInfo,
          status: queryArg.status,
          examDateFrom: queryArg.examDateFrom,
          examDateTo: queryArg.examDateTo,
        },
      }),
    }),
    postV2Terminals: build.mutation<
      PostV2TerminalsApiResponse,
      PostV2TerminalsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals`,
        method: "POST",
        body: queryArg,
      }),
    }),
    getV2TerminalsById: build.query<
      GetV2TerminalsByIdApiResponse,
      GetV2TerminalsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Terminals/${queryArg}` }),
    }),
    putV2TerminalsById: build.mutation<
      PutV2TerminalsByIdApiResponse,
      PutV2TerminalsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changeTerminalRequest,
      }),
    }),
    getV2TerminalsBySerialNumberBySerialNumber: build.query<
      GetV2TerminalsBySerialNumberBySerialNumberApiResponse,
      GetV2TerminalsBySerialNumberBySerialNumberApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/BySerialNumber/${queryArg}`,
      }),
    }),
    getV2TerminalsAvailability: build.query<
      GetV2TerminalsAvailabilityApiResponse,
      GetV2TerminalsAvailabilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/Availability`,
        params: {
          terminalIds: queryArg,
        },
      }),
    }),
    postV2TerminalsByIdReboot: build.mutation<
      PostV2TerminalsByIdRebootApiResponse,
      PostV2TerminalsByIdRebootApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg}/Reboot`,
        method: "POST",
      }),
    }),
    putV2TerminalsByIdVerificationDate: build.mutation<
      PutV2TerminalsByIdVerificationDateApiResponse,
      PutV2TerminalsByIdVerificationDateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.id}/VerificationDate`,
        method: "PUT",
        params: {
          verificationDate: queryArg.verificationDate,
        },
      }),
    }),
    putV2TerminalsByIdStatus: build.mutation<
      PutV2TerminalsByIdStatusApiResponse,
      PutV2TerminalsByIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.id}/Status`,
        method: "PUT",
        params: {
          status: queryArg.status,
        },
      }),
    }),
    putV2TerminalsByIdVersion: build.mutation<
      PutV2TerminalsByIdVersionApiResponse,
      PutV2TerminalsByIdVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.id}/Version`,
        method: "PUT",
        params: {
          terminalVersion: queryArg.terminalVersion,
        },
      }),
    }),
    putV2TerminalsByIdDevices: build.mutation<
      PutV2TerminalsByIdDevicesApiResponse,
      PutV2TerminalsByIdDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.id}/Devices`,
        method: "PUT",
        body: queryArg.changeTerminalDevicesRequest,
      }),
    }),
    putV2TerminalsByIdType: build.mutation<
      PutV2TerminalsByIdTypeApiResponse,
      PutV2TerminalsByIdTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.id}/Type`,
        method: "PUT",
        params: {
          type: queryArg["type"],
        },
      }),
    }),
    getV2TerminalsByTerminalIdThermohygrometerData: build.query<
      GetV2TerminalsByTerminalIdThermohygrometerDataApiResponse,
      GetV2TerminalsByTerminalIdThermohygrometerDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg}/ThermohygrometerData`,
      }),
    }),
    postV2TerminalsByTerminalIdThermohygrometerData: build.mutation<
      PostV2TerminalsByTerminalIdThermohygrometerDataApiResponse,
      PostV2TerminalsByTerminalIdThermohygrometerDataApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.terminalId}/ThermohygrometerData`,
        method: "POST",
        body: queryArg.addThermohygrometerDataRequest,
      }),
    }),
    getV2TerminalsByTerminalIdThermohygrometerDataClosest: build.query<
      GetV2TerminalsByTerminalIdThermohygrometerDataClosestApiResponse,
      GetV2TerminalsByTerminalIdThermohygrometerDataClosestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Terminals/${queryArg.terminalId}/ThermohygrometerData/Closest`,
        params: {
          dateTime: queryArg.dateTime,
        },
      }),
    }),
    getV2Users: build.query<GetV2UsersApiResponse, GetV2UsersApiArg>({
      query: (queryArg) => ({
        url: `/v2/Users`,
        params: {
          page: queryArg.page,
          offset: queryArg.offset,
          sort: queryArg.sort,
          searchInfo: queryArg.searchInfo,
          roleNames: queryArg.roleNames,
        },
      }),
    }),
    getV2UsersById: build.query<
      GetV2UsersByIdApiResponse,
      GetV2UsersByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Users/${queryArg}` }),
    }),
    getV2UsersByNameIsUnique: build.query<
      GetV2UsersByNameIsUniqueApiResponse,
      GetV2UsersByNameIsUniqueApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Users/${queryArg}/IsUnique` }),
    }),
    postV2UsersImport: build.mutation<
      PostV2UsersImportApiResponse,
      PostV2UsersImportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Users/Import`,
        method: "POST",
        body: queryArg.body,
        params: {
          organizationId: queryArg.organizationId,
          medOrganizationId: queryArg.medOrganizationId,
        },
      }),
    }),
    putV2UsersByIdStatus: build.mutation<
      PutV2UsersByIdStatusApiResponse,
      PutV2UsersByIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Users/${queryArg.id}/Status`,
        method: "PUT",
        params: {
          status: queryArg.status,
        },
      }),
    }),
    putV2UsersByIdName: build.mutation<
      PutV2UsersByIdNameApiResponse,
      PutV2UsersByIdNameApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Users/${queryArg.id}/Name`,
        method: "PUT",
        params: {
          name: queryArg.name,
        },
      }),
    }),
    putV2UsersByNamePassword: build.mutation<
      PutV2UsersByNamePasswordApiResponse,
      PutV2UsersByNamePasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Users/${queryArg.name}/Password`,
        method: "PUT",
        body: queryArg.changePasswordRequest,
      }),
    }),
    putV2UsersByNameResetPassword: build.mutation<
      PutV2UsersByNameResetPasswordApiResponse,
      PutV2UsersByNameResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Users/${queryArg.name}/ResetPassword`,
        method: "PUT",
        body: queryArg.resetPasswordRequest,
      }),
    }),
    getV2DoctorsByDoctorIdWorkPlaces: build.query<
      GetV2DoctorsByDoctorIdWorkPlacesApiResponse,
      GetV2DoctorsByDoctorIdWorkPlacesApiArg
    >({
      query: (queryArg) => ({ url: `/v2/Doctors/${queryArg}/WorkPlaces` }),
    }),
    postV2DoctorsByDoctorIdWorkPlaces: build.mutation<
      PostV2DoctorsByDoctorIdWorkPlacesApiResponse,
      PostV2DoctorsByDoctorIdWorkPlacesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Doctors/${queryArg.doctorId}/WorkPlaces`,
        method: "POST",
        body: queryArg.addWorkPlaceRequest,
      }),
    }),
    getV2DoctorsByDoctorIdWorkPlacesAndId: build.query<
      GetV2DoctorsByDoctorIdWorkPlacesAndIdApiResponse,
      GetV2DoctorsByDoctorIdWorkPlacesAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Doctors/${queryArg.doctorId}/WorkPlaces/${queryArg.id}`,
      }),
    }),
    putV2DoctorsByDoctorIdWorkPlacesAndId: build.mutation<
      PutV2DoctorsByDoctorIdWorkPlacesAndIdApiResponse,
      PutV2DoctorsByDoctorIdWorkPlacesAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Doctors/${queryArg.doctorId}/WorkPlaces/${queryArg.id}`,
        method: "PUT",
        body: queryArg.changeWorkPlaceRequest,
      }),
    }),
    deleteV2DoctorsByDoctorIdWorkPlacesAndId: build.mutation<
      DeleteV2DoctorsByDoctorIdWorkPlacesAndIdApiResponse,
      DeleteV2DoctorsByDoctorIdWorkPlacesAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/Doctors/${queryArg.doctorId}/WorkPlaces/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as apiRTK };
export type PostV2AdminsApiResponse = /** status 200 OK */ CreateAdminResponse;
export type PostV2AdminsApiArg = CreateAdminCommand;
export type GetV2ExamsByExamIdAlcoTestProcsAndIdApiResponse =
  /** status 200 OK */ GetAlcoTestProcResponse;
export type GetV2ExamsByExamIdAlcoTestProcsAndIdApiArg = {
  /** Идентификатор процедуры */
  id: number;
  /** Идентификатор осмотра */
  examId: number;
};
export type PostV2ExamsByExamIdAlcoTestProcsStartApiResponse = unknown;
export type PostV2ExamsByExamIdAlcoTestProcsStartApiArg =
  /** Идентификатор осмотра */ number;
export type PostV2ExamsByExamIdAlcoTestProcsApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2ExamsByExamIdAlcoTestProcsApiArg = {
  /** Идентификатор осмотра */
  examId: number;
  addAlcoTestProcRequest: AddAlcoTestProcRequest;
};
export type GetV2QuizesByQuizIdAnswersApiResponse =
  /** status 200 OK */ AnswerModel[];
export type GetV2QuizesByQuizIdAnswersApiArg =
  /** Идентификатор опроса */ number;
export type GetV2QuizesByQuizIdAnswersAndIdApiResponse =
  /** status 200 OK */ AnswerModel;
export type GetV2QuizesByQuizIdAnswersAndIdApiArg = {
  /** Идентификатор ответа на вопрос */
  id: number;
  /** Идентификатор опроса */
  quizId: number;
};
export type PostV2QuizesByQuizIdAnswersListApiResponse = unknown;
export type PostV2QuizesByQuizIdAnswersListApiArg = {
  /** Идентификатор опроса */
  quizId: number;
  addAnswerListRequest: AddAnswerListRequest;
};
export type GetV2TerminalsByTerminalIdApiKeysApiResponse =
  /** status 200 OK */ ApiKeyDto;
export type GetV2TerminalsByTerminalIdApiKeysApiArg =
  /** Идентификатор терминала */ number;
export type PostV2TerminalsByTerminalIdApiKeysApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2TerminalsByTerminalIdApiKeysApiArg = {
  /** Идентификатор терминала */
  terminalId: number;
  /** Модель апи ключа */
  addApiKeyRequest: AddApiKeyRequest;
};
export type PostAuthenticationLoginApiResponse =
  /** status 200 OK */ BearerTokensResponse;
export type PostAuthenticationLoginApiArg = LoginRequest;
export type PostAuthenticationRefreshTokenApiResponse =
  /** status 200 OK */ BearerTokensResponse;
export type PostAuthenticationRefreshTokenApiArg = RefreshTokenRequest;
export type GetV2ExamsByExamIdBloodPressProcsAndIdApiResponse =
  /** status 200 OK */ GetBloodPressProcResponse;
export type GetV2ExamsByExamIdBloodPressProcsAndIdApiArg = {
  /** Идентификатор процедуры */
  id: number;
  /** Идентификатор осмотра */
  examId: number;
};
export type PostV2ExamsByExamIdBloodPressProcsStartApiResponse = unknown;
export type PostV2ExamsByExamIdBloodPressProcsStartApiArg =
  /** Идентификатор осмотра */ number;
export type PostV2ExamsByExamIdBloodPressProcsApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2ExamsByExamIdBloodPressProcsApiArg = {
  /** Идентификатор осмотра */
  examId: number;
  addBloodPressProcRequest: AddBloodPressProcRequest;
};
export type GetV2PersonsByPersonIdCertificatesApiResponse =
  /** status 200 OK */ CertificateModel[];
export type GetV2PersonsByPersonIdCertificatesApiArg = {
  /** Идентификатор физ. лица */
  personId: number;
  /** Флаг активности сертификата */
  isActive?: boolean;
};
export type PostV2PersonsByPersonIdCertificatesApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2PersonsByPersonIdCertificatesApiArg = {
  /** Идентификатор физ. лица */
  personId: number;
  /** Модель сертификата */
  addCertificateRequest: AddCertificateRequest;
};
export type PutV2PersonsByPersonIdCertificatesAndIdStatusApiResponse = unknown;
export type PutV2PersonsByPersonIdCertificatesAndIdStatusApiArg = {
  /** Идентификатор сертификата */
  id: number;
  /** Новое значение свойства */
  isActive: boolean;
  /** Идентификатор физ. лица */
  personId: number;
};
export type GetV2ExamsByExamIdConclusionsApiResponse =
  /** status 200 OK */ GetConclusionResponse;
export type GetV2ExamsByExamIdConclusionsApiArg =
  /** Идентификатор осмотра */ number;
export type PostV2ExamsByExamIdConclusionsApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2ExamsByExamIdConclusionsApiArg = {
  /** Идентификатор осмотра */
  examId: number;
  addConclusionRequest: AddConclusionRequest;
};
export type GetV2ExamsConclusionsStatisticsApiResponse =
  /** status 200 OK */ ConclusionStatisticsModel;
export type GetV2ExamsConclusionsStatisticsApiArg =
  /** Дата начала в статистике */ string;
export type GetV2PatientsByPatientIdExamsConclusionsApiResponse =
  /** status 200 OK */ GetPatientSignedConclusionsResponse[];
export type GetV2PatientsByPatientIdExamsConclusionsApiArg = {
  /** Идентификатор пациента */
  patientId: number;
  /** Дата начала выборки */
  since?: string;
};
export type GetV2ConclusionsByIdStickerApiResponse = unknown;
export type GetV2ConclusionsByIdStickerApiArg =
  /** Идентификатор заключения */ number;
export type PostV2ExamsByExamIdConclusionsAndIdGenerateDocumentApiResponse =
  /** status 200 OK */ FileUploadModel;
export type PostV2ExamsByExamIdConclusionsAndIdGenerateDocumentApiArg = {
  /** Идентификатор заключения */
  id: number;
  /** Идентификатор осмотра */
  examId: number;
};
export type PostV2ExamsByExamIdConclusionsAndIdSignApiResponse = unknown;
export type PostV2ExamsByExamIdConclusionsAndIdSignApiArg = {
  /** Идентификатор заключения */
  id: number;
  /** Идентификатор осмотра */
  examId: number;
  /** Идентификатор сертификата */
  certificateId: number;
  body: {
    /** Файл подписи */
    signFile?: Blob;
  };
};
export type PostV2DirectorsApiResponse =
  /** status 200 OK */ CreateDirectorResponse;
export type PostV2DirectorsApiArg = CreateDirectorCommand;
export type GetV2PersonsByPersonIdDoctorsApiResponse =
  /** status 200 OK */ DoctorModel;
export type GetV2PersonsByPersonIdDoctorsApiArg =
  /** Идентификатор физ. лица */ number;
export type GetV2MedOrganizationsByMedOrganizationIdDoctorsApiResponse =
  /** status 200 OK */ GetDoctorsByMedOrganizationResponse[];
export type GetV2MedOrganizationsByMedOrganizationIdDoctorsApiArg =
  /** Идентификатор медицинской организации */ number;
export type PostV2DoctorsApiResponse =
  /** status 200 OK */ CreateDoctorResponse;
export type PostV2DoctorsApiArg = CreateDoctorCommand;
export type PutV2PersonsByPersonIdDoctorsAndIdApiResponse = unknown;
export type PutV2PersonsByPersonIdDoctorsAndIdApiArg = {
  /** Идентификатор врача */
  id: number;
  /** Идентификатор физ. лица */
  personId: number;
  /** Модель врача */
  changeDoctorRequest: ChangeDoctorRequest;
};
export type PutV2PatientsByPatientIdDriverLicensesAndIdApiResponse = unknown;
export type PutV2PatientsByPatientIdDriverLicensesAndIdApiArg = {
  /** Идентификатор обследуемого */
  patientId: number;
  /** Идентификатор водительского удостоверения */
  id: number;
  driverLicenseDto: DriverLicenseDto;
};
export type DeleteV2PatientsByPatientIdDriverLicensesAndIdApiResponse = unknown;
export type DeleteV2PatientsByPatientIdDriverLicensesAndIdApiArg = {
  /** Идентификатор обследуемого */
  patientId: number;
  /** Идентификатор водительского удостоверения */
  id: number;
};
export type GetV2DoctorsByDoctorIdEducationsApiResponse =
  /** status 200 OK */ EducationModel[];
export type GetV2DoctorsByDoctorIdEducationsApiArg =
  /** Идентификатор врача */ number;
export type PostV2DoctorsByDoctorIdEducationsApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2DoctorsByDoctorIdEducationsApiArg = {
  /** Идентификатор врача */
  doctorId: number;
  addEducationRequest: AddEducationRequest;
};
export type PutV2DoctorsByDoctorIdEducationsAndIdApiResponse = unknown;
export type PutV2DoctorsByDoctorIdEducationsAndIdApiArg = {
  /** Идентификатор образования */
  id: number;
  /** Идентификатор врача */
  doctorId: number;
  changeEducationRequest: ChangeEducationRequest;
};
export type DeleteV2DoctorsByDoctorIdEducationsAndIdApiResponse = unknown;
export type DeleteV2DoctorsByDoctorIdEducationsAndIdApiArg = {
  /** Идентификатор образования */
  id: number;
  /** Идентификатор врача */
  doctorId: number;
};
export type PostV2ExamsByExamIdMediasProcedurePhotoApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2ExamsByExamIdMediasProcedurePhotoApiArg = {
  /** Идентификатор осмотра */
  examId: number;
  /** Стадия осмотра */
  stage: MediaStageEnum;
  body: {
    /** Файл фото процедуры */
    photoFile: Blob;
  };
};
export type PostV2ExamsByExamIdMediasVideoApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2ExamsByExamIdMediasVideoApiArg = {
  /** Идентификатор осмотра */
  examId: number;
  body: {
    /** Файл видео осмотра */
    videoFile: Blob;
  };
};
export type GetV2ExamsApiResponse =
  /** status 200 OK */ GetAllExamsResponsePagedListModelRead;
export type GetV2ExamsApiArg = {
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Строка для поиска (Patient.FirstName, Patient.LastName, Patient.Patronymic) */
  searchInfo?: string;
  /** Строка для сортировки (time, fio, birth, gender, status, type) */
  sort?: string;
  /** Статусы осмотра (через запятую) */
  statuses?: string;
  /** Допущен ли обследуемый к поездке по результатам заключения врача */
  isAdmitted?: boolean;
  /** Получить осмотры только за сегодня или за любой день, кроме сегодня */
  isToday?: boolean;
  /** Идентификаторы организаций через запятую */
  organizationIds?: string;
  /** Идентификаторы терминалов через запятую */
  terminalIds?: string;
};
export type GetV2ExamsByIdApiResponse =
  /** status 200 OK */ GetAllExamsResponseRead;
export type GetV2ExamsByIdApiArg = /** Идентификатор осмотра */ number;
export type GetV2PatientsByPatientIdExamsApiResponse =
  /** status 200 OK */ GetAllExamsResponseRead[];
export type GetV2PatientsByPatientIdExamsApiArg = {
  /** Идентификатор обследуемого */
  patientId: number;
  /** Идентификатор крайнего осмотра */
  lastId?: number;
  /** Строка для фильтрации (open, closed, unsigned, failed) */
  filter?: string;
  /** Минимальная дата начала осмотра */
  minStartDate?: string;
};
export type GetV2PatientsByPatientIdExamsAvailableTypesApiResponse =
  /** status 200 OK */ GetAvailableExamTypesResponse;
export type GetV2PatientsByPatientIdExamsAvailableTypesApiArg =
  /** Идентификатор обследуемого */ number;
export type PostV2ExamsStartApiResponse =
  /** status 200 OK */ StartExamResponse;
export type PostV2ExamsStartApiArg =
  /** Модель запуска осмотра */ StartExamRequest;
export type PostV2ExamsByIdBreakApiResponse = unknown;
export type PostV2ExamsByIdBreakApiArg = {
  /** Идентификатор осмотра */
  id: number;
  /** Причина прерывания осмотра */
  failReason: ExamFailReasonEnum;
};
export type PutV2ExamsByIdStatusApiResponse = unknown;
export type PutV2ExamsByIdStatusApiArg = {
  /** Идентификатор осмотра */
  id: number;
  /** Статус осмотра */
  statusType: ExamStatusEnum;
};
export type PostV2ExternalDoctorsApiResponse =
  /** status 200 OK */ CreateExternalDoctorResponse;
export type PostV2ExternalDoctorsApiArg = CreateExternalDoctorCommand;
export type GetV2FaceVerificationResultsEventsApiResponse = unknown;
export type GetV2FaceVerificationResultsEventsApiArg =
  /** Идентификатор осмотра */ number;
export type GetV2FilesDownloadUrlApiResponse = /** status 200 OK */ UrlModel;
export type GetV2FilesDownloadUrlApiArg = {
  /** Тип файла */
  fileType: FileTypeEnum;
  /** Ключ файла в хранилище */
  key: string;
};
export type PostV2FilesOtherUploadApiResponse =
  /** status 200 OK */ FileUploadModel;
export type PostV2FilesOtherUploadApiArg = {
  file: Blob;
};
export type PostV2LicenseDataApiResponse =
  /** status 200 OK */ LicenseDataModelRead;
export type PostV2LicenseDataApiArg =
  /** Модель запроса с данными для лицензии */ GenerateLicenseDataRequest;
export type PostV2TerminalsByTerminalIdLuxmeterDataApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2TerminalsByTerminalIdLuxmeterDataApiArg = {
  /** Идентификатор терминала */
  terminalId: number;
  /** Модель создания данных люксметра */
  addLuxmeterDataRequest: AddLuxmeterDataRequest;
};
export type GetV2TerminalsByTerminalIdLuxmeterDataApiResponse =
  /** status 200 OK */ LuxmeterDataModel[];
export type GetV2TerminalsByTerminalIdLuxmeterDataApiArg =
  /** Идентификатор терминала */ number;
export type GetV2TerminalsByTerminalIdLuxmeterDataClosestApiResponse =
  /** status 200 OK */ LuxmeterDataModel;
export type GetV2TerminalsByTerminalIdLuxmeterDataClosestApiArg = {
  /** Дата и время в UTC */
  dateTime: string;
  /** Идентификатор терминала */
  terminalId: number;
};
export type GetV2MedOrganizationsApiResponse =
  /** status 200 OK */ MedOrganizationResponsePagedListModelRead;
export type GetV2MedOrganizationsApiArg = {
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Строка для поиска (name, inn, ogrn, medLicence) */
  searchInfo?: string;
  /** Строка для сортировки (name, inn, ogrn, medLicence) */
  sort?: string;
};
export type PostV2MedOrganizationsApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2MedOrganizationsApiArg =
  /** Модель мед. организации */ AddMedOrganizationRequest;
export type GetV2MedOrganizationsByIdApiResponse =
  /** status 200 OK */ MedOrganizationModel;
export type GetV2MedOrganizationsByIdApiArg =
  /** Идентификатор мед. организации */ number;
export type PutV2MedOrganizationsByIdApiResponse = unknown;
export type PutV2MedOrganizationsByIdApiArg = {
  /** Идентификатор мед. организации */
  id: number;
  /** Модель мед. организации */
  changeMedOrganizationRequest: ChangeMedOrganizationRequest;
};
export type DeleteV2MedOrganizationsByIdApiResponse = unknown;
export type DeleteV2MedOrganizationsByIdApiArg =
  /** Идентификатор мед. организации */ number;
export type GetV2OrganizationsByOrganizationIdMedOrganizationsApiResponse =
  /** status 200 OK */ MedOrganizationResponse[];
export type GetV2OrganizationsByOrganizationIdMedOrganizationsApiArg =
  /** Идентификатор организации */ number;
export type GetV2ExamsByExamIdMindTestsAndIdApiResponse =
  /** status 200 OK */ GetMindTestResponse;
export type GetV2ExamsByExamIdMindTestsAndIdApiArg = {
  /** Идентификатор процедуры */
  id: number;
  /** Идентификатор осмотра */
  examId: number;
};
export type PostV2ExamsByExamIdMindTestsApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2ExamsByExamIdMindTestsApiArg = {
  /** Идентификатор осмотра */
  examId: number;
  /** Модель создания процедуры */
  addMindTestRequest: AddMindTestRequest;
};
export type GetV2PersonsByPersonIdNotificationsApiResponse =
  /** status 200 OK */ NotificationModelPagedListModelRead;
export type GetV2PersonsByPersonIdNotificationsApiArg = {
  /** Идентификатор физ. лица */
  personId: number;
  /** Флаг прочтения пользователем сообщения */
  isRead?: boolean;
  /** Типы уведомлений */
  types?: NotificationTypeEnum[];
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Строка для сортировки (isRead, time) */
  sort?: string;
};
export type DeleteV2PersonsByPersonIdNotificationsApiResponse = unknown;
export type DeleteV2PersonsByPersonIdNotificationsApiArg =
  /** Идентификатор физ. лица */ number;
export type PutV2PersonsByPersonIdNotificationsAndIdReadApiResponse = unknown;
export type PutV2PersonsByPersonIdNotificationsAndIdReadApiArg = {
  /** Идентификатор уведомления */
  id: number;
  /** Идентификатор физ. лица */
  personId: number;
};
export type PutV2PersonsByPersonIdNotificationsReadApiResponse = unknown;
export type PutV2PersonsByPersonIdNotificationsReadApiArg =
  /** Идентификатор физ. лица */ number;
export type DeleteV2PersonsByPersonIdNotificationsAndIdApiResponse = unknown;
export type DeleteV2PersonsByPersonIdNotificationsAndIdApiArg = {
  /** Идентификатор уведомления */
  id: number;
  /** Идентификатор физ. лица */
  personId: number;
};
export type PutV2PersonsByPersonIdNotificationsTokenApiResponse = unknown;
export type PutV2PersonsByPersonIdNotificationsTokenApiArg = {
  /** Идентификатор физ. лица */
  personId: number;
  /** Токен нотификации */
  notificationToken?: string;
};
export type GetV2OrganizationsApiResponse =
  /** status 200 OK */ OrganizationModelPagedListModelRead;
export type GetV2OrganizationsApiArg = {
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Строка для поиска (name, inn, ogrn) */
  searchInfo?: string;
  /** Строка для сортировки (name, inn, ogrn, email, address, phone) */
  sort?: string;
};
export type PostV2OrganizationsApiResponse = /** status 200 OK */ IdResponseDto;
export type PostV2OrganizationsApiArg =
  /** Модель организации */ AddOrganizationRequest;
export type GetV2OrganizationsByIdApiResponse =
  /** status 200 OK */ OrganizationModel;
export type GetV2OrganizationsByIdApiArg =
  /** Идентификатор организации */ number;
export type PutV2OrganizationsByIdApiResponse = unknown;
export type PutV2OrganizationsByIdApiArg = {
  /** Идентификатор организации */
  id: number;
  /** Модель организации */
  changeOrganizationRequest: ChangeOrganizationRequest;
};
export type DeleteV2OrganizationsByIdApiResponse =
  /** status 200 OK */ RemoveOrganizationResponse;
export type DeleteV2OrganizationsByIdApiArg =
  /** Идентификатор организации */ number;
export type GetV2MedOrganizationsByMedOrganizationIdOrganizationsApiResponse =
  /** status 200 OK */ GetOrganizationsByMedOrganizationResponseItem[];
export type GetV2MedOrganizationsByMedOrganizationIdOrganizationsApiArg =
  /** Идентификатор медицинской организации */ number;
export type PostV2OrganizationsByIdMedOrganizationsAndMedOrganizationIdApiResponse =
  unknown;
export type PostV2OrganizationsByIdMedOrganizationsAndMedOrganizationIdApiArg =
  {
    /** Идентификатор организации */
    id: number;
    /** Идентификатор мед. организации */
    medOrganizationId: number;
  };
export type DeleteV2OrganizationsByIdMedOrganizationsAndMedOrganizationIdApiResponse =
  unknown;
export type DeleteV2OrganizationsByIdMedOrganizationsAndMedOrganizationIdApiArg =
  {
    /** Идентификатор организации */
    id: number;
    /** Идентификатор мед. организации */
    medOrganizationId: number;
  };
export type GetV2PersonsByPersonalNumberByPersonalNumberPatientsApiResponse =
  /** status 200 OK */ GetPatientResponse;
export type GetV2PersonsByPersonalNumberByPersonalNumberPatientsApiArg =
  /** Уникальный номер работника */ string;
export type GetV2PersonsBySnilsBySnilsPatientsApiResponse =
  /** status 200 OK */ GetPatientBySnilsResponse;
export type GetV2PersonsBySnilsBySnilsPatientsApiArg = /** СНИЛС */ string;
export type GetV2PersonsByPersonIdPatientsApiResponse =
  /** status 200 OK */ GetPatientResponse;
export type GetV2PersonsByPersonIdPatientsApiArg =
  /** Идентификатор физ. лица */ number;
export type GetV2OrganizationsByOrganizationIdPatientsApiResponse =
  /** status 200 OK */ GetPatientsByOrganizationResponsePagedListModelRead;
export type GetV2OrganizationsByOrganizationIdPatientsApiArg = {
  /** Идентификатор организации */
  organizationId: number;
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Строка для сортировки (lastName) */
  sort?: string;
};
export type GetV2PatientsByExternalIdByExternalIdApiResponse =
  /** status 200 OK */ GetPatientByExternalIdResponse;
export type GetV2PatientsByExternalIdByExternalIdApiArg =
  /** Идентификатор обследуемого во внешней системе */ string;
export type PostV2PatientsApiResponse =
  /** status 200 OK */ CreatePatientResponse;
export type PostV2PatientsApiArg = CreatePatientCommand;
export type PutV2PersonsByPersonIdPatientsAndIdApiResponse = unknown;
export type PutV2PersonsByPersonIdPatientsAndIdApiArg = {
  /** Идентификатор обследуемого */
  id: number;
  /** Идентификатор физ. лица */
  personId: number;
  /** Модель обследуемого */
  changePatientRequest: ChangePatientRequest;
};
export type PutV2PersonsByPersonIdPatientsAndIdActivityApiResponse = unknown;
export type PutV2PersonsByPersonIdPatientsAndIdActivityApiArg = {
  /** Идентификатор обследуемого */
  id: number;
  /** Идентификатор обследуемого */
  personId: number;
  /** Флаг активности пользователя */
  isActive: boolean;
};
export type GetV2PersonsByPersonIdPhotosApiResponse =
  /** status 200 OK */ GetPersonPhotoResponse[];
export type GetV2PersonsByPersonIdPhotosApiArg =
  /** Идентификатор физ. лица */ number;
export type PostV2PersonsByPersonIdPhotosApiResponse =
  /** status 200 OK */ CreatePersonPhotoResponse;
export type PostV2PersonsByPersonIdPhotosApiArg = {
  /** Идентификатор физ. лица */
  personId: number;
  body: {
    file: Blob;
  };
};
export type PutV2PersonsByPersonIdPhotosAndIdApiResponse = unknown;
export type PutV2PersonsByPersonIdPhotosAndIdApiArg = {
  /** Идентификатор фото физ. лица */
  id: number;
  /** Идентификатор физ. лица */
  personId: number;
  /** Модель фото физ. лица */
  changePersonPhotoRequest: ChangePersonPhotoRequest;
};
export type DeleteV2PersonsByPersonIdPhotosAndIdApiResponse = unknown;
export type DeleteV2PersonsByPersonIdPhotosAndIdApiArg = {
  /** Идентификатор фото физ. лица */
  id: number;
  /** Идентификатор физ. лица */
  personId: number;
};
export type PutV2PersonsByPersonIdPhotosStatusApiResponse = unknown;
export type PutV2PersonsByPersonIdPhotosStatusApiArg = {
  /** Идентификатор физ. лица */
  personId: number;
  /** Решение по заявке: 0 - отклонить, 1 - одобрить */
  status: PersonPhotoRequestStatusEnum;
};
export type GetV2PersonsApiResponse =
  /** status 200 OK */ GetAllPersonsResponseItemPagedListModelRead;
export type GetV2PersonsApiArg = {
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Строка для сортировки (lastname, birthdate, position) */
  sort?: string;
  /** Строка для поиска (FirstName, LastName, Patronymic, Email, Phone) */
  searchInfo?: string;
  /** Роли пользователя (через "+") */
  roleNames?: string;
  /** Статус пользователя */
  userStatus?: UserStatusEnum;
};
export type GetV2PersonsByIdApiResponse =
  /** status 200 OK */ GetPersonResponse;
export type GetV2PersonsByIdApiArg = /** Идентификатор физ. лица */ number;
export type PutV2PersonsByIdApiResponse = unknown;
export type PutV2PersonsByIdApiArg = {
  /** Идентификатор физ. лица */
  id: number;
  /** Модель физ. лица */
  changePersonRequest: ChangePersonRequest;
};
export type GetV2PersonsPersonalNumberByPersonalNumberIsUniqueApiResponse =
  /** status 200 OK */ boolean;
export type GetV2PersonsPersonalNumberByPersonalNumberIsUniqueApiArg =
  /** Табельный номер */ string;
export type GetV2PersonsSnilsBySnilsIsUniqueApiResponse =
  /** status 200 OK */ boolean;
export type GetV2PersonsSnilsBySnilsIsUniqueApiArg = /** СНИЛС */ string;
export type GetV2PostTripJournalsApiResponse =
  /** status 200 OK */ JournalModelPagedListModelRead;
export type GetV2PostTripJournalsApiArg = {
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Направление сортировки (asc, desc) */
  sortOrder?: string;
  /** Дата */
  date: string;
  /** Часовой пояс */
  timezone: number;
};
export type GetV2PostTripJournalsByIdApiResponse =
  /** status 200 OK */ JournalModel;
export type GetV2PostTripJournalsByIdApiArg =
  /** Идентификатор журнала */ number;
export type GetV2PostTripJournalsDatesApiResponse =
  /** status 200 OK */ DateOnlyPagedListModelRead;
export type GetV2PostTripJournalsDatesApiArg = {
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Часовой пояс */
  timezone: number;
  /** Направление сортировки (asc, desc) */
  sortOrder?: string;
  /** Дата от */
  dateFrom?: string;
  /** Дата до */
  dateTo?: string;
};
export type GetV2PostTripJournalsDocumentApiResponse =
  /** status 200 OK */ Blob;
export type GetV2PostTripJournalsDocumentApiArg = {
  /** Дата от */
  startDate: string;
  /** Дата до */
  endDate: string;
  /** Формат сформированного документа: 0 - PDF, 1 - XLSX */
  fileExtension?: FileExtensionsEnum;
};
export type PostV2PostTripJournalsByIdSignApiResponse = unknown;
export type PostV2PostTripJournalsByIdSignApiArg = {
  /** Идентификатор журнала */
  id: number;
  signJournalRequest: SignJournalRequest;
};
export type PostV2ExamsByExamIdPostTripJournalsSignApiResponse = unknown;
export type PostV2ExamsByExamIdPostTripJournalsSignApiArg = {
  /** Идентификатор осмотра */
  examId: number;
  signJournalRequest: SignJournalRequest;
};
export type GetV2ExamsByExamIdPostTripJournalsHashApiResponse =
  /** status 200 OK */ HashModel;
export type GetV2ExamsByExamIdPostTripJournalsHashApiArg =
  /** Идентификатор осмотра */ number;
export type GetV2PostTripJournalsByIdHashApiResponse =
  /** status 200 OK */ HashModel;
export type GetV2PostTripJournalsByIdHashApiArg =
  /** Идентификатор журнала */ number;
export type GetV2PreTripJournalsApiResponse =
  /** status 200 OK */ JournalModelPagedListModelRead;
export type GetV2PreTripJournalsApiArg = {
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Направление сортировки (asc, desc) */
  sortOrder?: string;
  /** Дата */
  date: string;
  /** Часовой пояс */
  timezone: number;
};
export type GetV2PreTripJournalsByIdApiResponse =
  /** status 200 OK */ JournalModel;
export type GetV2PreTripJournalsByIdApiArg =
  /** Идентификатор журнала */ number;
export type GetV2PreTripJournalsDatesApiResponse =
  /** status 200 OK */ DateOnlyPagedListModelRead;
export type GetV2PreTripJournalsDatesApiArg = {
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Часовой пояс */
  timezone: number;
  /** Направление сортировки (asc, desc) */
  sortOrder?: string;
  /** Дата от */
  dateFrom?: string;
  /** Дата до */
  dateTo?: string;
};
export type GetV2PreTripJournalsDocumentApiResponse = /** status 200 OK */ Blob;
export type GetV2PreTripJournalsDocumentApiArg = {
  /** Дата от */
  startDate: string;
  /** Дата до */
  endDate: string;
  /** Формат сформированного документа: 0 - PDF, 1 - XLSX */
  fileExtension?: FileExtensionsEnum;
};
export type PostV2PreTripJournalsByIdSignApiResponse = unknown;
export type PostV2PreTripJournalsByIdSignApiArg = {
  /** Идентификатор журнала */
  id: number;
  signJournalRequest: SignJournalRequest;
};
export type PostV2ExamsByExamIdPreTripJournalsSignApiResponse = unknown;
export type PostV2ExamsByExamIdPreTripJournalsSignApiArg = {
  /** Идентификатор осмотра */
  examId: number;
  signJournalRequest: SignJournalRequest;
};
export type GetV2ExamsByExamIdPreTripJournalsHashApiResponse =
  /** status 200 OK */ HashModel;
export type GetV2ExamsByExamIdPreTripJournalsHashApiArg =
  /** Идентификатор осмотра */ number;
export type GetV2PreTripJournalsByIdHashApiResponse =
  /** status 200 OK */ HashModel;
export type GetV2PreTripJournalsByIdHashApiArg =
  /** Идентификатор журнала */ number;
export type GetV2ProcedureDevicesApiResponse =
  /** status 200 OK */ ProcedureDeviceDto[];
export type GetV2ProcedureDevicesApiArg = void;
export type GetV2ProcedureDevicesByNameByNameApiResponse =
  /** status 200 OK */ ProcedureDeviceDto;
export type GetV2ProcedureDevicesByNameByNameApiArg =
  /** Название устройства */ string;
export type PutV2ProcedureDevicesByIdApiResponse = unknown;
export type PutV2ProcedureDevicesByIdApiArg = {
  /** Идентификатор устройства */
  id: number;
  /** Модель устройства */
  changeProcedureDeviceRequest: ChangeProcedureDeviceRequest;
};
export type GetV2QuestionsApiResponse = /** status 200 OK */ QuestionModel[];
export type GetV2QuestionsApiArg = void;
export type PostV2ExamsByExamIdQuizesApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2ExamsByExamIdQuizesApiArg = {
  /** Идентификатор осмотра */
  examId: number;
  addQuizRequest: AddQuizRequest;
};
export type GetV2ReasonsApiResponse = /** status 200 OK */ ReasonModel[];
export type GetV2ReasonsApiArg = void;
export type GetV2ReasonsByIdApiResponse = /** status 200 OK */ ReasonModel;
export type GetV2ReasonsByIdApiArg = /** Идентификатор причины */ number;
export type GetV2PatientsByPatientIdReferenceIndicatorsApiResponse =
  /** status 200 OK */ ReferenceIndicatorDto;
export type GetV2PatientsByPatientIdReferenceIndicatorsApiArg =
  /** Идентификатор обследуемого */ number;
export type PostV2PatientsByPatientIdReferenceIndicatorsApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2PatientsByPatientIdReferenceIndicatorsApiArg = {
  /** Идентификатор обследуемого */
  patientId: number;
  /** Модель создания референтных значений */
  addReferenceIndicatorRequest: AddReferenceIndicatorRequest;
};
export type PutV2PatientsByPatientIdReferenceIndicatorsAndIdApiResponse =
  unknown;
export type PutV2PatientsByPatientIdReferenceIndicatorsAndIdApiArg = {
  /** Идентификатор референтных значений */
  id: number;
  /** Идентификатор обследуемого */
  patientId: number;
  /** Модель референтных значений */
  changeReferenceIndicatorRequest: ChangeReferenceIndicatorRequest;
};
export type DeleteV2PatientsByPatientIdReferenceIndicatorsAndIdApiResponse =
  unknown;
export type DeleteV2PatientsByPatientIdReferenceIndicatorsAndIdApiArg = {
  /** Идентификатор референтных значений */
  id: number;
  /** Идентификатор обследуемого */
  patientId: number;
};
export type GetV2ReportsGeneratePivotTableApiResponse =
  /** status 200 OK */ Blob;
export type GetV2ReportsGeneratePivotTableApiArg = {
  /** Дата от */
  startDate: string;
  /** Дата до */
  endDate: string;
};
export type GetV2ReportsGenerateExamReportApiResponse =
  /** status 200 OK */ Blob;
export type GetV2ReportsGenerateExamReportApiArg = {
  /** Дата от */
  startDate: string;
  /** Дата до */
  endDate: string;
};
export type GetV2RolesApiResponse = /** status 200 OK */ RoleModel[];
export type GetV2RolesApiArg = void;
export type GetV2UsersByUserIdRolesApiResponse =
  /** status 200 OK */ RoleModel[];
export type GetV2UsersByUserIdRolesApiArg =
  /** Идентификатор пользователя */ number;
export type PostV2UsersByUserIdRolesAdminApiResponse = unknown;
export type PostV2UsersByUserIdRolesAdminApiArg =
  /** Идентификатор пользователя */ number;
export type PostV2UsersByUserIdRolesDirectorApiResponse = unknown;
export type PostV2UsersByUserIdRolesDirectorApiArg =
  /** Идентификатор пользователя */ number;
export type PostV2UsersByUserIdRolesDoctorApiResponse =
  /** status 200 OK */ AssignDoctorRoleResponse;
export type PostV2UsersByUserIdRolesDoctorApiArg = {
  /** Идентификатор пользователя */
  userId: number;
  assignDoctorRoleRequest: AssignDoctorRoleRequest;
};
export type DeleteV2UsersByUserIdRolesAndIdApiResponse = unknown;
export type DeleteV2UsersByUserIdRolesAndIdApiArg = {
  /** Идентификатор пользователя */
  userId: number;
  /** Идентификатор роли */
  id: number;
};
export type GetV2ExamsSetSseConnectionApiResponse = unknown;
export type GetV2ExamsSetSseConnectionApiArg = void;
export type GetV2SpecialitiesApiResponse =
  /** status 200 OK */ SpecialityModel[];
export type GetV2SpecialitiesApiArg = void;
export type GetV2ExamsByExamIdSpeechTestsAndIdApiResponse =
  /** status 200 OK */ GetSpeechTestResponse;
export type GetV2ExamsByExamIdSpeechTestsAndIdApiArg = {
  /** Идентификатор этапа */
  id: number;
  /** Идентификатор осмотра */
  examId: number;
};
export type PostV2ExamsByExamIdSpeechTestsApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2ExamsByExamIdSpeechTestsApiArg = {
  /** Идентификатор осмотра */
  examId: number;
  /** Длительность записи в секундах */
  durationSec: number;
  body: {
    /** Файл записи */
    file: Blob;
  };
};
export type GetSystemRabbitInfoApiResponse =
  /** status 200 OK */ RabbitInfoModelRead;
export type GetSystemRabbitInfoApiArg = void;
export type GetSystemApiVersionsApiResponse =
  /** status 200 OK */ ApiVersionModel;
export type GetSystemApiVersionsApiArg = void;
export type GetSystemClientsVersionsApiResponse =
  /** status 200 OK */ ClientsBuildsModel[];
export type GetSystemClientsVersionsApiArg =
  /** Платформа, для которой требуется получить версии (phone, tablet, raspberry) */
    | string
    | undefined;
export type GetV2ExamsByExamIdTemperatureProcsAndIdApiResponse =
  /** status 200 OK */ GetTemperatureProcResponse;
export type GetV2ExamsByExamIdTemperatureProcsAndIdApiArg = {
  /** Идентификатор процедуры */
  id: number;
  /** Идентификатор осмотра */
  examId: number;
};
export type PostV2ExamsByExamIdTemperatureProcsStartApiResponse = unknown;
export type PostV2ExamsByExamIdTemperatureProcsStartApiArg =
  /** Идентификатор осмотра */ number;
export type PostV2ExamsByExamIdTemperatureProcsApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2ExamsByExamIdTemperatureProcsApiArg = {
  /** Идентификатор осмотра */
  examId: number;
  addTemperatureProcRequest: AddTemperatureProcRequest;
};
export type GetV2TerminalsByTerminalIdCaseOpeningsApiResponse =
  /** status 200 OK */ TerminalCaseOpeningModel;
export type GetV2TerminalsByTerminalIdCaseOpeningsApiArg =
  /** Идентификатор терминала */ number;
export type PutV2TerminalsByTerminalIdCaseOpeningsIncrementApiResponse =
  unknown;
export type PutV2TerminalsByTerminalIdCaseOpeningsIncrementApiArg =
  /** Идентификатор терминала */ number;
export type PostV2TerminalsByTerminalIdChecksumsApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2TerminalsByTerminalIdChecksumsApiArg = {
  /** Идентификатор терминала */
  terminalId: number;
  addTerminalChecksumRequest: AddTerminalChecksumRequest;
};
export type PutV2TerminalsByTerminalIdChecksumsAndIdApiResponse = unknown;
export type PutV2TerminalsByTerminalIdChecksumsAndIdApiArg = {
  /** Идентификатор терминала */
  terminalId: number;
  /** Идентификатор контрольной суммы */
  id: number;
  changeTerminalChecksumRequest: ChangeTerminalChecksumRequest;
};
export type DeleteV2TerminalsByTerminalIdChecksumsAndIdApiResponse = unknown;
export type DeleteV2TerminalsByTerminalIdChecksumsAndIdApiArg = {
  /** Идентификатор терминала */
  terminalId: number;
  /** Идентификатор контрольной суммы */
  id: number;
};
export type GetV2TerminalsByTerminalIdEventsApiResponse =
  /** status 200 OK */ TerminalEventModelPagedListModelRead;
export type GetV2TerminalsByTerminalIdEventsApiArg = {
  /** Идентификатор терминала */
  terminalId: number;
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Строка для сортировки (time) */
  sort?: string;
};
export type PostV2TerminalsByTerminalIdEventsApiResponse = unknown;
export type PostV2TerminalsByTerminalIdEventsApiArg = {
  /** Идентификатор терминала */
  terminalId: number;
  addTerminalEventRequest: AddTerminalEventRequest;
};
export type GetV2TerminalsApiResponse =
  /** status 200 OK */ TerminalModelPagedListModelRead;
export type GetV2TerminalsApiArg = {
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Строка для сортировки (addr, serial, timezone) */
  sort?: string;
  /** Строка для поиска (SerialNumber, Address) */
  searchInfo?: string;
  /** Статус терминала */
  status?: TerminalStatusEnum;
  /** Начальная дата диапазона осмотров (включительно) */
  examDateFrom?: string;
  /** Конечная дата диапазона осмотров (включительно) */
  examDateTo?: string;
};
export type PostV2TerminalsApiResponse = /** status 200 OK */ IdResponseDto;
export type PostV2TerminalsApiArg = /** Модель терминала */ AddTerminalRequest;
export type GetV2TerminalsByIdApiResponse = /** status 200 OK */ TerminalModel;
export type GetV2TerminalsByIdApiArg = /** Идентификатор терминала */ number;
export type PutV2TerminalsByIdApiResponse = unknown;
export type PutV2TerminalsByIdApiArg = {
  /** Идентификатор терминала */
  id: number;
  /** Модель терминала */
  changeTerminalRequest: ChangeTerminalRequest;
};
export type GetV2TerminalsBySerialNumberBySerialNumberApiResponse =
  /** status 200 OK */ GetTerminalBySerialNumberResponseRead;
export type GetV2TerminalsBySerialNumberBySerialNumberApiArg =
  /** Серийный номер терминала */ string;
export type GetV2TerminalsAvailabilityApiResponse =
  /** status 200 OK */ CheckTerminalAvailabilityResponse[];
export type GetV2TerminalsAvailabilityApiArg =
  /** Идентификаторы терминалов */ string;
export type PostV2TerminalsByIdRebootApiResponse = unknown;
export type PostV2TerminalsByIdRebootApiArg =
  /** Идентификатор терминала */ number;
export type PutV2TerminalsByIdVerificationDateApiResponse = unknown;
export type PutV2TerminalsByIdVerificationDateApiArg = {
  /** Идентификатор терминала */
  id: number;
  /** Дата поверки */
  verificationDate: string;
};
export type PutV2TerminalsByIdStatusApiResponse = unknown;
export type PutV2TerminalsByIdStatusApiArg = {
  /** Идентификатор терминала */
  id: number;
  /** Статус терминала */
  status: TerminalStatusEnum;
};
export type PutV2TerminalsByIdVersionApiResponse = unknown;
export type PutV2TerminalsByIdVersionApiArg = {
  /** Идентификатор терминала */
  id: number;
  /** Версия ПО терминала */
  terminalVersion: string;
};
export type PutV2TerminalsByIdDevicesApiResponse = unknown;
export type PutV2TerminalsByIdDevicesApiArg = {
  /** Идентификатор терминала */
  id: number;
  changeTerminalDevicesRequest: ChangeTerminalDevicesRequest;
};
export type PutV2TerminalsByIdTypeApiResponse = unknown;
export type PutV2TerminalsByIdTypeApiArg = {
  /** Идентификатор терминала */
  id: number;
  /** Тип терминала */
  type: TerminalTypeEnum;
};
export type GetV2TerminalsByTerminalIdThermohygrometerDataApiResponse =
  /** status 200 OK */ ThermohygrometerDataResponse[];
export type GetV2TerminalsByTerminalIdThermohygrometerDataApiArg =
  /** Идентификатор терминала */ number;
export type PostV2TerminalsByTerminalIdThermohygrometerDataApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2TerminalsByTerminalIdThermohygrometerDataApiArg = {
  /** Идентификатор терминала */
  terminalId: number;
  /** Модель для добавления данных термогигрометра */
  addThermohygrometerDataRequest: AddThermohygrometerDataRequest;
};
export type GetV2TerminalsByTerminalIdThermohygrometerDataClosestApiResponse =
  /** status 200 OK */ ThermohygrometerDataResponse;
export type GetV2TerminalsByTerminalIdThermohygrometerDataClosestApiArg = {
  /** Дата в UTC */
  dateTime: string;
  /** Идентификатор терминала */
  terminalId: number;
};
export type GetV2UsersApiResponse =
  /** status 200 OK */ UserDtoPagedListModelRead;
export type GetV2UsersApiArg = {
  /** Номер требуемой страницы */
  page?: number;
  /** Количество результатов на странице */
  offset?: number;
  /** Строка для сортировки (name) */
  sort?: string;
  /** Строка для поиска (UserName) */
  searchInfo?: string;
  /** Роли пользователя (через "+") */
  roleNames?: string;
};
export type GetV2UsersByIdApiResponse = /** status 200 OK */ UserDto;
export type GetV2UsersByIdApiArg = /** Идентификатор пользователя */ number;
export type GetV2UsersByNameIsUniqueApiResponse = /** status 200 OK */ boolean;
export type GetV2UsersByNameIsUniqueApiArg = /** Имя пользователя */ string;
export type PostV2UsersImportApiResponse =
  /** status 200 OK */ ImportUsersResponse;
export type PostV2UsersImportApiArg = {
  /** Идентификатор организации */
  organizationId: number;
  /** Идентификатор медицинской организации */
  medOrganizationId: number;
  body: {
    /** Excel файл с информацией о пользователях */
    file: Blob;
  };
};
export type PutV2UsersByIdStatusApiResponse = unknown;
export type PutV2UsersByIdStatusApiArg = {
  /** Идентификатор пользователя */
  id: number;
  /** Статус пользователя */
  status: UserStatusEnum;
};
export type PutV2UsersByIdNameApiResponse = unknown;
export type PutV2UsersByIdNameApiArg = {
  /** Идентификатор пользователя */
  id: number;
  /** Новое имя пользователя */
  name: string;
};
export type PutV2UsersByNamePasswordApiResponse = unknown;
export type PutV2UsersByNamePasswordApiArg = {
  /** Имя пользователя */
  name: string;
  /** Модель запроса */
  changePasswordRequest: ChangePasswordRequest;
};
export type PutV2UsersByNameResetPasswordApiResponse = unknown;
export type PutV2UsersByNameResetPasswordApiArg = {
  /** Имя пользователя */
  name: string;
  /** Модель запроса */
  resetPasswordRequest: ResetPasswordRequest;
};
export type GetV2DoctorsByDoctorIdWorkPlacesApiResponse =
  /** status 200 OK */ WorkPlaceModel[];
export type GetV2DoctorsByDoctorIdWorkPlacesApiArg =
  /** Идентификатор врача */ number;
export type PostV2DoctorsByDoctorIdWorkPlacesApiResponse =
  /** status 200 OK */ IdResponseDto;
export type PostV2DoctorsByDoctorIdWorkPlacesApiArg = {
  /** Идентификатор врача */
  doctorId: number;
  /** Модель места работы */
  addWorkPlaceRequest: AddWorkPlaceRequest;
};
export type GetV2DoctorsByDoctorIdWorkPlacesAndIdApiResponse =
  /** status 200 OK */ WorkPlaceModel;
export type GetV2DoctorsByDoctorIdWorkPlacesAndIdApiArg = {
  /** Идентификатор места работы */
  id: number;
  /** Идентификатор врача */
  doctorId: number;
};
export type PutV2DoctorsByDoctorIdWorkPlacesAndIdApiResponse = unknown;
export type PutV2DoctorsByDoctorIdWorkPlacesAndIdApiArg = {
  /** Идентификатор места работы */
  id: number;
  /** Идентификатор врача */
  doctorId: number;
  /** Модель места работы */
  changeWorkPlaceRequest: ChangeWorkPlaceRequest;
};
export type DeleteV2DoctorsByDoctorIdWorkPlacesAndIdApiResponse = unknown;
export type DeleteV2DoctorsByDoctorIdWorkPlacesAndIdApiArg = {
  /** Идентификатор места работы */
  id: number;
  /** Идентификатор врача */
  doctorId: number;
};
export type CreateAdminResponse = {
  userId: number;
  personId: number;
};
export type GenderEnum = 0 | 1;
export type CreateAdminCommand = {
  login: string;
  password: string;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  birthDate: string;
  gender: GenderEnum;
  email?: string | null;
  phone: string;
  personalNumber?: string | null;
  position: string;
};
export type AlcoUnitTypeEnum = 0 | 1;
export type GetAlcoTestProcResponse = {
  id: number;
  examId: number;
  isSuccess: boolean;
  finishedAt: string;
  value?: number | null;
  unitType: AlcoUnitTypeEnum;
  errorMessage?: string | null;
};
export type IdResponseDto = {
  id: number;
};
export type AddAlcoTestProcRequest = {
  value?: number | null;
  durationSec: number;
  unitType: AlcoUnitTypeEnum;
  errorMessage?: string | null;
};
export type AnswerModel = {
  id: number;
  questionId: number;
  quizId: number;
  ynAnswer?: boolean | null;
  value?: string | null;
};
export type AddAnswerDto = {
  questionId: number;
  ynAnswer?: boolean | null;
  value?: string | null;
};
export type AddAnswerListRequest = {
  answers: AddAnswerDto[];
};
export type ApiKeyDto = {
  terminalApiKey: string;
  deviceApiKey: string;
  terminalId: number;
};
export type AddApiKeyRequest = {
  terminalApiKey: string;
  deviceApiKey: string;
  serialNumber: string;
};
export type BearerTokensResponse = {
  access: string;
  refresh: string;
};
export type LoginRequest = {
  login: string;
  password: string;
};
export type RefreshTokenRequest = {
  refresh: string;
};
export type GetBloodPressProcResponse = {
  id: number;
  examId: number;
  isSuccess: boolean;
  finishedAt: string;
  systPress?: number | null;
  diastPress?: number | null;
  pulse?: number | null;
  errorMessage?: string | null;
};
export type AddBloodPressProcRequest = {
  systPress?: number | null;
  diastPress?: number | null;
  pulse?: number | null;
  durationSec: number;
  errorMessage?: string | null;
};
export type CertificateModel = {
  id: number;
  description: string;
  isActive: boolean;
  issuer?: string | null;
  startDate: string;
  endDate: string;
  personId: number;
  subject?: string | null;
  thumbprint: string;
  x509Certificate: string;
};
export type AddCertificateRequest = {
  description: string;
  isActive: boolean;
  issuer?: string | null;
  startDate: string;
  endDate: string;
  subject?: string | null;
  thumbprint: string;
  x509Certificate: string;
};
export type ReasonDto = {
  id: number;
  value: string;
};
export type PersonPhotoStatusEnum = 0 | 1 | 2;
export type GetPersonPhotoResponse = {
  id: number;
  personId: number;
  status: PersonPhotoStatusEnum;
  storageKey: string;
};
export type GetPersonResponse = {
  id: number;
  userId: number;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  birthDate: string;
  gender: GenderEnum;
  email?: string | null;
  phone: string;
  personalNumber?: string | null;
  snils?: string | null;
  position: string;
  notificationToken?: string | null;
  personPhotos?: GetPersonPhotoResponse[] | null;
};
export type OrganizationDto = {
  id: number;
  name: string;
  inn?: string | null;
  ogrn?: string | null;
  isIp: boolean;
  contactFIO: string;
  contactPost?: string | null;
  contactPhone?: string | null;
  address: string;
  phone: string;
  email?: string | null;
  isPersonPhotoRequired: boolean;
};
export type DriverLicenseDto = {
  series: string;
  number: string;
  issuedAt: string;
  expiresAt: string;
};
export type GetPatientResponse = {
  id: number;
  isActive: boolean;
  personId: number;
  person: GetPersonResponse;
  organizationId?: number | null;
  organization?: OrganizationDto;
  driverLicense?: DriverLicenseDto;
};
export type QualificationTypeEnum = 0 | 1 | 2;
export type ScientificDegreeTypeEnum = 0 | 1;
export type GetConclusionDoctorDto = {
  id: number;
  qualificationType?: QualificationTypeEnum;
  scientificDegreeType?: ScientificDegreeTypeEnum;
  workExperience?: number | null;
  isActive: boolean;
  personId: number;
  person?: GetPersonResponse;
};
export type GetConclusionResponse = {
  id: number;
  examId: number;
  isAdmitted: boolean;
  reasonId?: number | null;
  reason?: ReasonDto;
  reportDate: string;
  patientId: number;
  patient?: GetPatientResponse;
  doctorId: number;
  doctor?: GetConclusionDoctorDto;
  storageKey?: string | null;
  signStorageKey?: string | null;
  certificateId?: number | null;
  reasonComment?: string | null;
};
export type AddConclusionRequest = {
  doctorId: number;
  isAdmitted: boolean;
  reasonId?: number | null;
  reasonComment?: string | null;
};
export type ReasonsModel = {
  alcohol?: number;
  temperature?: number;
  pressure?: number;
  other?: number;
};
export type ConclusionStatisticsModel = {
  startDate?: string;
  endDate?: string;
  admitted?: number;
  notAdmitted?: number;
  reasons?: ReasonsModel;
};
export type ExamTypeEnum = 0 | 1 | 2 | 3;
export type GetPatientSignedConclusionsResponse = {
  id?: number;
  reportDate?: string;
  examType?: ExamTypeEnum;
};
export type FileUploadModel = {
  storageKey: string;
};
export type CreateDirectorResponse = {
  userId: number;
  personId: number;
};
export type CreateDirectorCommand = {
  login: string;
  password: string;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  birthDate: string;
  gender: GenderEnum;
  email?: string | null;
  phone: string;
  personalNumber?: string | null;
  position: string;
};
export type DoctorModel = {
  id: number;
  personId: number;
  qualificationType?: QualificationTypeEnum;
  scientificDegreeType?: ScientificDegreeTypeEnum;
  workExperience?: number | null;
  medOrganizationId?: number | null;
  isActive: boolean;
};
export type GetDoctorsByMedOrganizationResponsePersonPhotoDto = {
  id: number;
  storageKey: string;
  status: PersonPhotoStatusEnum;
};
export type GetDoctorsByMedOrganizationResponsePersonDto = {
  id: number;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  position: string;
  personPhotos: GetDoctorsByMedOrganizationResponsePersonPhotoDto[];
};
export type GetDoctorsByMedOrganizationResponse = {
  id: number;
  qualificationType?: QualificationTypeEnum;
  person: GetDoctorsByMedOrganizationResponsePersonDto;
};
export type CreateDoctorResponse = {
  userId: number;
  personId: number;
  doctorId: number;
};
export type CreateDoctorCommand = {
  login: string;
  password: string;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  birthDate: string;
  gender: GenderEnum;
  email?: string | null;
  phone: string;
  snils: string;
  personalNumber?: string | null;
  position: string;
  medOrganizationId: number;
  qualificationType?: QualificationTypeEnum;
  scientificDegreeType?: ScientificDegreeTypeEnum;
  workExperience?: number | null;
};
export type ChangeDoctorRequest = {
  medOrganizationId: number;
  qualificationType?: QualificationTypeEnum;
  scientificDegreeType?: ScientificDegreeTypeEnum;
  workExperience?: number | null;
  isActive: boolean;
};
export type EducationTypeEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export type EducationModel = {
  id: number;
  doctorId: number;
  universityName: string;
  educationType: EducationTypeEnum;
  specialityId?: number | null;
  startDate: string;
  endDate: string;
};
export type AddEducationRequest = {
  universityName: string;
  educationType: EducationTypeEnum;
  specialityId?: number | null;
  startDate: string;
  endDate: string;
};
export type ChangeEducationRequest = {
  universityName: string;
  educationType: EducationTypeEnum;
  specialityId?: number | null;
  startDate: string;
  endDate: string;
};
export type MediaStageEnum = 0 | 10 | 20 | 21 | 22;
export type ExamStatusEnum = 10 | 20 | 30 | 35 | 40 | 45 | 50 | 300;
export type ExamFailReasonEnum =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14;
export type TerminalStatusEnum = 0 | 1 | 2 | 3 | 4 | 5;
export type QuizTypeEnum = 0 | 1;
export type TerminalDto = {
  id: number;
  serialNumber: string;
  status: TerminalStatusEnum;
  isMobile: boolean;
  hasHints: boolean;
  quizType: QuizTypeEnum;
  hasSpeechTest: boolean;
  hasMindTest: boolean;
  address: string;
  alcoJoinTemp: boolean;
};
export type PersonPhoto = {
  id: number;
  status: PersonPhotoStatusEnum;
};
export type IntegrationEvent = object;
export type PersonPhotoRead = {
  id: number;
  integrationEvents?: IntegrationEvent[] | null;
  storageKey?: string | null;
  status: PersonPhotoStatusEnum;
  personId: number;
  creationDate: string;
};
export type PersonDto = {
  id: number;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  birthDate: string;
  gender: GenderEnum;
  email?: string | null;
  phone: string;
  personalNumber?: string | null;
  position: string;
  notificationToken?: string | null;
  personPhotos?: PersonPhoto[] | null;
};
export type PersonDtoRead = {
  id: number;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  birthDate: string;
  gender: GenderEnum;
  email?: string | null;
  phone: string;
  personalNumber?: string | null;
  position: string;
  notificationToken?: string | null;
  personPhotos?: PersonPhotoRead[] | null;
};
export type PatientDto = {
  id: number;
  isActive?: boolean;
  personId: number;
  person: PersonDto;
};
export type PatientDtoRead = {
  id: number;
  isActive?: boolean;
  personId: number;
  person: PersonDtoRead;
};
export type AnswerDto = {
  id: number;
  ynAnswer?: boolean | null;
  value?: string | null;
  questionId: number;
};
export type QuizDto = {
  id: number;
  quizType: QuizTypeEnum;
  procDate: string;
  answers?: AnswerDto[] | null;
};
export type DoctorDto = {
  id: number;
  qualificationType?: QualificationTypeEnum;
  scientificDegreeType?: ScientificDegreeTypeEnum;
  workExperience?: number | null;
  isActive: boolean;
  personId: number;
  person: PersonDto;
};
export type DoctorDtoRead = {
  id: number;
  qualificationType?: QualificationTypeEnum;
  scientificDegreeType?: ScientificDegreeTypeEnum;
  workExperience?: number | null;
  isActive: boolean;
  personId: number;
  person: PersonDtoRead;
};
export type CertificateDto = {
  id: number;
  description: string;
  isActive: boolean;
  issuer?: string | null;
  startDate: string;
  endDate: string;
  subject?: string | null;
  thumbprint: string;
  personId: number;
};
export type ConclusionDto = {
  id: number;
  isAdmitted: boolean;
  reportDate: string;
  storageKey?: string | null;
  signStorageKey?: string | null;
  doctorId: number;
  doctor: DoctorDto;
  certificateId?: number | null;
  certificate?: CertificateDto;
  reasonId?: number | null;
  reason?: ReasonDto;
};
export type ConclusionDtoRead = {
  id: number;
  isAdmitted: boolean;
  reportDate: string;
  storageKey?: string | null;
  signStorageKey?: string | null;
  doctorId: number;
  doctor: DoctorDtoRead;
  certificateId?: number | null;
  certificate?: CertificateDto;
  reasonId?: number | null;
  reason?: ReasonDto;
};
export type SpeechTestDto = {
  id: number;
  finishedAt: string;
  storageKey: string;
};
export type MindTestAttentionLevelEnum = 0 | 1 | 2;
export type MindTestDto = {
  id: number;
  finishedAt: string;
  elapsedTime: number;
  mistakes: number;
  score: number;
  attentionLevel: MindTestAttentionLevelEnum;
};
export type BloodPressProcDto = {
  id: number;
  isSuccess: boolean;
  errorMessage?: string | null;
  finishedAt: string;
  systPress?: number | null;
  diastPress?: number | null;
  pulse?: number | null;
};
export type AlcoTestProcDto = {
  id: number;
  isSuccess: boolean;
  errorMessage?: string | null;
  finishedAt: string;
  value?: number | null;
  unitType: AlcoUnitTypeEnum;
};
export type TempUnitTypeEnum = 0 | 1;
export type TemperatureProcDto = {
  id: number;
  isSuccess: boolean;
  errorMessage?: string | null;
  finishedAt: string;
  value?: number | null;
  unitType: TempUnitTypeEnum;
};
export type MediaTypeEnum = 0 | 1;
export type FaceVerificationStatusEnum = 0 | 1 | 2;
export type FaceVerificationResultDto = {
  id: number;
  score?: number | null;
  status: FaceVerificationStatusEnum;
  processedAt?: string | null;
};
export type MediaDto = {
  id: number;
  storageKey: string;
  mediaType: MediaTypeEnum;
  stage?: MediaStageEnum;
  faceVerificationResults?: FaceVerificationResultDto[] | null;
};
export type GetAllExamsResponse = {
  id: number;
  startDate: string;
  endDate?: string | null;
  statusType: ExamStatusEnum;
  agreement: string;
  examType: ExamTypeEnum;
  failReason?: ExamFailReasonEnum;
  terminalId: number;
  terminal: TerminalDto;
  patientId: number;
  patient: PatientDto;
  quizId?: number | null;
  quiz?: QuizDto;
  conclusionId?: number | null;
  conclusion?: ConclusionDto;
  speechTestProcs: SpeechTestDto[];
  mindTestProcs: MindTestDto[];
  bloodPressureProcs: BloodPressProcDto[];
  alcoTestProcs: AlcoTestProcDto[];
  temperatureProcs: TemperatureProcDto[];
  medias: MediaDto[];
};
export type GetAllExamsResponseRead = {
  id: number;
  startDate: string;
  endDate?: string | null;
  statusType: ExamStatusEnum;
  agreement: string;
  examType: ExamTypeEnum;
  failReason?: ExamFailReasonEnum;
  terminalId: number;
  terminal: TerminalDto;
  patientId: number;
  patient: PatientDtoRead;
  quizId?: number | null;
  quiz?: QuizDto;
  conclusionId?: number | null;
  conclusion?: ConclusionDtoRead;
  speechTestProcs: SpeechTestDto[];
  mindTestProcs: MindTestDto[];
  bloodPressureProcs: BloodPressProcDto[];
  alcoTestProcs: AlcoTestProcDto[];
  temperatureProcs: TemperatureProcDto[];
  medias: MediaDto[];
};
export type GetAllExamsResponsePagedListModel = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: GetAllExamsResponse[] | null;
};
export type GetAllExamsResponsePagedListModelRead = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: GetAllExamsResponseRead[] | null;
  totalPages?: number | null;
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
};
export type GetAvailableExamTypesResponse = {
  preTrip?: boolean;
  postTrip?: boolean;
  preShift?: boolean;
  postShift?: boolean;
};
export type StartExamDto = {
  id?: number;
};
export type StartExamResponse = {
  isSuccess?: boolean;
  reason?: string | null;
  exam?: StartExamDto;
};
export type StartExamRequest = {
  terminalSerialNumber: string;
  patientId: number;
  examType: ExamTypeEnum;
};
export type CreateExternalDoctorResponse = {
  userId: number;
  personId: number;
};
export type CreateExternalDoctorCommand = {
  login: string;
  password: string;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  birthDate: string;
  gender: GenderEnum;
  email?: string | null;
  phone: string;
  position: string;
};
export type UrlModel = {
  url: string;
};
export type FileTypeEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
export type LicenseDataModel = {};
export type LicenseDataModelRead = {
  requestId?: string;
  hostName?: string | null;
  type?: string | null;
  value?: number;
  hwId?: string | null;
  timestamp?: string;
};
export type GenerateLicenseDataRequest = {
  type: string;
  value: number;
};
export type AddLuxmeterDataRequest = {
  luminosity: number;
  examId?: number | null;
};
export type LuxmeterDataModel = {
  id: number;
  scanDate: string;
  luminosity: number;
  terminalId: number;
  examId?: number | null;
};
export type MedOrganizationResponse = {
  id: number;
  name: string;
  inn?: string | null;
  ogrn?: string | null;
  address: string;
  phone: string;
  medLicence: string;
};
export type MedOrganizationResponsePagedListModel = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: MedOrganizationResponse[] | null;
};
export type MedOrganizationResponsePagedListModelRead = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: MedOrganizationResponse[] | null;
  totalPages?: number | null;
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
};
export type AddMedOrganizationRequest = {
  name: string;
  inn: string;
  ogrn: string;
  isIp: boolean;
  contactFIO: string;
  contactPost?: string | null;
  contactPhone: string;
  address: string;
  phone?: string | null;
  email?: string | null;
  medLicence: string;
  recReestrMO?: string | null;
  numReestrMO?: string | null;
};
export type MedOrganizationModel = {
  name: string;
  inn: string;
  ogrn?: string | null;
  isIp: boolean;
  contactFIO: string;
  contactPost?: string | null;
  contactPhone: string;
  address: string;
  phone?: string | null;
  email?: string | null;
  id: number;
  medLicence: string;
  recReestrMO?: string | null;
  numReestrMO?: string | null;
  moTypeId?: number | null;
};
export type ChangeMedOrganizationRequest = {
  medLicence: string;
  recReestrMO?: string | null;
  numReestrMO?: string | null;
  name: string;
  inn: string;
  ogrn: string;
  isIp: boolean;
  contactFIO: string;
  contactPost?: string | null;
  contactPhone: string;
  address: string;
  phone?: string | null;
  email?: string | null;
};
export type GetMindTestResponse = {
  id: number;
  examId: number;
  finishedAt: string;
  elapsedTime: number;
  mistakes: number;
  score: number;
  attentionLevel: MindTestAttentionLevelEnum;
};
export type AddMindTestRequest = {
  durationSec: number;
  mistakes: number;
  scores: number;
  attentionLevel: MindTestAttentionLevelEnum;
};
export type NotificationTypeEnum =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11;
export type NotificationModel = {
  id: number;
  personId: number;
  messageJson: string;
  isRead: boolean;
  type: NotificationTypeEnum;
  creationDate: string;
};
export type NotificationModelPagedListModel = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: NotificationModel[] | null;
};
export type NotificationModelPagedListModelRead = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: NotificationModel[] | null;
  totalPages?: number | null;
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
};
export type OrganizationModel = {
  name: string;
  inn: string;
  ogrn?: string | null;
  isIp: boolean;
  contactFIO: string;
  contactPost?: string | null;
  contactPhone: string;
  address: string;
  phone?: string | null;
  email?: string | null;
  id: number;
  isPersonPhotoRequired: boolean;
};
export type OrganizationModelPagedListModel = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: OrganizationModel[] | null;
};
export type OrganizationModelPagedListModelRead = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: OrganizationModel[] | null;
  totalPages?: number | null;
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
};
export type AddOrganizationRequest = {
  isPersonPhotoRequired: boolean;
  name: string;
  inn: string;
  ogrn: string;
  isIp: boolean;
  contactFIO: string;
  contactPost?: string | null;
  contactPhone: string;
  address: string;
  phone?: string | null;
  email?: string | null;
};
export type ChangeOrganizationRequest = {
  isPersonPhotoRequired: boolean;
  name: string;
  inn: string;
  ogrn: string;
  isIp: boolean;
  contactFIO: string;
  contactPost?: string | null;
  contactPhone: string;
  address: string;
  phone?: string | null;
  email?: string | null;
};
export type RemoveOrganizationResponse = {
  deactivatedUsersCount?: number;
};
export type GetOrganizationsByMedOrganizationResponseItem = {
  id: number;
  name: string;
};
export type GetPatientBySnilsPersonPhotoDto = {
  id: number;
  fileName: string;
  status: PersonPhotoStatusEnum;
};
export type GetPatientBySnilsOrganizationDto = {
  isPersonPhotoRequired: boolean;
};
export type GetPatientBySnilsResponse = {
  id: number;
  shortFio: string;
  personPhotos: GetPatientBySnilsPersonPhotoDto[];
  organization: GetPatientBySnilsOrganizationDto;
};
export type GetPatientsByOrganizationResponsePersonPhotoDto = {
  id: number;
  storageKey: string;
  status: PersonPhotoStatusEnum;
};
export type GetPatientsByOrganizationResponsePersonDto = {
  id: number;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  position: string;
  personPhotos: GetPatientsByOrganizationResponsePersonPhotoDto[];
};
export type GetPatientsByOrganizationResponse = {
  id: number;
  person: GetPatientsByOrganizationResponsePersonDto;
};
export type GetPatientsByOrganizationResponsePagedListModel = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: GetPatientsByOrganizationResponse[] | null;
};
export type GetPatientsByOrganizationResponsePagedListModelRead = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: GetPatientsByOrganizationResponse[] | null;
  totalPages?: number | null;
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
};
export type GetPatientByExternalIdResponse = {
  patientId: number;
  personId: number;
};
export type CreatePatientResponse = {
  userId: number;
  personId: number;
  patientId: number;
};
export type CreatePatientCommand = {
  login?: string | null;
  password?: string | null;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  birthDate: string;
  gender: GenderEnum;
  email?: string | null;
  phone: string;
  snils: string;
  personalNumber?: string | null;
  position: string;
  organizationId: number;
  driverLicense?: DriverLicenseDto;
};
export type ChangePatientRequest = {
  organizationId: number;
  driverLicense?: DriverLicenseDto;
};
export type CreatePersonPhotoResponse = {
  id: number;
  personId: number;
  status: PersonPhotoStatusEnum;
  storageKey: string;
};
export type ChangePersonPhotoRequest = {
  storageKey: string;
};
export type PersonPhotoRequestStatusEnum = 0 | 1;
export type GetAllPersonsResponseItem = {
  id: number;
  userId: number;
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  birthDate: string;
  gender: GenderEnum;
  phone: string;
  personalNumber?: string | null;
  position: string;
};
export type GetAllPersonsResponseItemPagedListModel = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: GetAllPersonsResponseItem[] | null;
};
export type GetAllPersonsResponseItemPagedListModelRead = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: GetAllPersonsResponseItem[] | null;
  totalPages?: number | null;
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
};
export type UserStatusEnum = 0 | 1;
export type ChangePersonRequest = {
  lastName: string;
  firstName: string;
  patronymic?: string | null;
  birthDate: string;
  gender: GenderEnum;
  email: string | null;
  phone: string;
  snils?: string | null;
  personalNumber?: string | null;
  position: string;
};
export type JournalModel = {
  id: number;
  examId?: number | null;
  reportDate: string;
  driverLastName: string;
  driverFirstName: string;
  driverPatronymic?: string | null;
  birthDate: string;
  gender: GenderEnum;
  hasComplaints: boolean;
  complaints?: string | null;
  systPres: number;
  diastPres: number;
  pulse: number;
  temperature: number;
  alco: number;
  isAdmitted: boolean;
  reasonText?: string | null;
  doctorId: number;
  doctorLastName: string;
  doctorFirstName: string;
  doctorPatronymic?: string | null;
  doctorThumbprint: string;
  hashSign?: string | null;
  signDate: string;
};
export type JournalModelPagedListModel = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: JournalModel[] | null;
};
export type JournalModelPagedListModelRead = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: JournalModel[] | null;
  totalPages?: number | null;
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
};
export type DateOnlyPagedListModel = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: string[] | null;
};
export type DateOnlyPagedListModelRead = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: string[] | null;
  totalPages?: number | null;
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
};
export type FileExtensionsEnum = 0 | 1;
export type SignJournalRequest = {
  signHash: string;
};
export type HashModel = {
  hash?: string | null;
};
export type ProcedureDeviceTypeEnum = 0 | 1 | 2;
export type ProcedureDeviceDto = {
  id: number;
  name: string;
  type: ProcedureDeviceTypeEnum;
  isManualStart: boolean;
  isSoundOn: boolean;
  timeout: number;
  frameOffset: number;
};
export type ChangeProcedureDeviceRequest = {
  name: string;
  type: ProcedureDeviceTypeEnum;
  isManualStart: boolean;
  isSoundOn: boolean;
  timeout: number;
  frameOffset: number;
};
export type QuestionModel = {
  id: number;
  number: string;
  value: string;
  hasAdditional: boolean;
};
export type AddQuizRequest = {
  durationSec: number;
  answers: AddAnswerDto[];
};
export type ReasonModel = {
  id: number;
  value: string;
  hasAdditional: boolean;
};
export type ReferenceIndicatorDto = {
  id: number;
  patientId: number;
  systLower: number;
  systUpper: number;
  diastLower: number;
  diastUpper: number;
  pulseLower: number;
  pulseUpper: number;
};
export type AddReferenceIndicatorRequest = {
  systLower: number;
  systUpper: number;
  diastLower: number;
  diastUpper: number;
  pulseLower: number;
  pulseUpper: number;
};
export type ChangeReferenceIndicatorRequest = {
  systLower: number;
  systUpper: number;
  diastLower: number;
  diastUpper: number;
  pulseLower: number;
  pulseUpper: number;
};
export type RoleModel = {
  id: number;
  name: string;
};
export type AssignDoctorRoleResponse = {
  doctorId?: number;
};
export type AssignDoctorRoleRequest = {
  qualificationType?: QualificationTypeEnum;
  scientificDegreeType?: ScientificDegreeTypeEnum;
  workExperience?: number | null;
  medOrganizationId: number;
};
export type SpecialityModel = {
  id: number;
  name: string;
};
export type GetSpeechTestResponse = {
  id: number;
  examId: number;
  finishedAt: string;
  storageKey: string;
};
export type RabbitInfoModel = {
  serverQueueName?: string | null;
  useSsl?: boolean;
};
export type RabbitInfoModelRead = {
  hostName?: string | null;
  virtualHost?: string | null;
  port?: number;
  serverQueueName?: string | null;
  useSsl?: boolean;
};
export type ApiVersionModel = {
  versions?: string[] | null;
};
export type ClientVersion = {
  version: string;
  url: string;
  latest: boolean;
};
export type ClientsBuildsModel = {
  name: string;
  versions?: ClientVersion[] | null;
};
export type GetTemperatureProcResponse = {
  id: number;
  examId: number;
  isSuccess: boolean;
  finishedAt: string;
  value?: number | null;
  unitType: TempUnitTypeEnum;
  errorMessage?: string | null;
};
export type AddTemperatureProcRequest = {
  value?: number | null;
  unitType: TempUnitTypeEnum;
  durationSec: number;
  errorMessage?: string | null;
};
export type TerminalCaseOpeningModel = {
  id: number;
  terminalId: number;
  count: number;
};
export type AddTerminalChecksumRequest = {
  path: string;
  algorithm: string;
  value: string;
};
export type ChangeTerminalChecksumRequest = {
  path: string;
  algorithm: string;
  value: string;
};
export type TerminalEventTypeEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
export type TerminalEventModel = {
  terminalId: number;
  scanDate: string;
  eventType: TerminalEventTypeEnum;
};
export type TerminalEventModelPagedListModel = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: TerminalEventModel[] | null;
};
export type TerminalEventModelPagedListModelRead = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: TerminalEventModel[] | null;
  totalPages?: number | null;
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
};
export type AddTerminalEventRequest = {
  eventType: TerminalEventTypeEnum;
};
export type TerminalTypeEnum = 0 | 1;
export type TerminalModel = {
  id: number;
  serialNumber: string;
  status: TerminalStatusEnum;
  type: TerminalTypeEnum;
  version: string;
  isMobile: boolean;
  hasHints: boolean;
  quizType: QuizTypeEnum;
  hasSpeechTest: boolean;
  hasMindTest: boolean;
  canRepeatProcedures: boolean;
  address: string;
  alcoJoinTemp: boolean;
  timezone: number;
  verificationDate: string;
  alcotesterDevice?: ProcedureDeviceDto;
  thermometerDevice?: ProcedureDeviceDto;
  tonometerDevice?: ProcedureDeviceDto;
};
export type TerminalModelPagedListModel = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: TerminalModel[] | null;
};
export type TerminalModelPagedListModelRead = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: TerminalModel[] | null;
  totalPages?: number | null;
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
};
export type AddTerminalRequest = {
  serialNumber: string;
  version?: string | null;
  isMobile: boolean;
  hasHints: boolean;
  quizType: QuizTypeEnum;
  hasSpeechTest: boolean;
  hasMindTest: boolean;
  canRepeatProcedures: boolean;
  address: string;
  timezone: number;
  alcoJoinTemp: boolean;
};
export type ChangeTerminalRequest = {
  serialNumber: string;
  isMobile: boolean;
  hasHints: boolean;
  quizType: QuizTypeEnum;
  hasSpeechTest: boolean;
  hasMindTest: boolean;
  canRepeatProcedures: boolean;
  address: string;
  timezone: number;
  alcoJoinTemp: boolean;
};
export type TerminalCaseOpening = {
  id: number;
  terminalId?: number;
  count?: number;
};
export type TerminalCaseOpeningRead = {
  id: number;
  integrationEvents?: IntegrationEvent[] | null;
  terminalId?: number;
  count?: number;
};
export type TerminalChecksumDto = {
  path?: string | null;
  algorithm?: string | null;
  value?: string | null;
  updatedAt?: string | null;
};
export type GetTerminalBySerialNumberResponse = {
  id: number;
  serialNumber: string;
  status: TerminalStatusEnum;
  type: TerminalTypeEnum;
  version: string;
  isMobile: boolean;
  hasHints: boolean;
  quizType: QuizTypeEnum;
  hasSpeechTest: boolean;
  hasMindTest: boolean;
  canRepeatProcedures: boolean;
  address: string;
  alcoJoinTemp: boolean;
  timezone: number;
  verificationDate: string;
  alcotesterDevice?: ProcedureDeviceDto;
  thermometerDevice?: ProcedureDeviceDto;
  tonometerDevice?: ProcedureDeviceDto;
  terminalCaseOpening?: TerminalCaseOpening;
  checksums?: TerminalChecksumDto[] | null;
};
export type GetTerminalBySerialNumberResponseRead = {
  id: number;
  serialNumber: string;
  status: TerminalStatusEnum;
  type: TerminalTypeEnum;
  version: string;
  isMobile: boolean;
  hasHints: boolean;
  quizType: QuizTypeEnum;
  hasSpeechTest: boolean;
  hasMindTest: boolean;
  canRepeatProcedures: boolean;
  address: string;
  alcoJoinTemp: boolean;
  timezone: number;
  verificationDate: string;
  alcotesterDevice?: ProcedureDeviceDto;
  thermometerDevice?: ProcedureDeviceDto;
  tonometerDevice?: ProcedureDeviceDto;
  terminalCaseOpening?: TerminalCaseOpeningRead;
  checksums?: TerminalChecksumDto[] | null;
};
export type CheckTerminalAvailabilityResponse = {
  id?: number;
  isAvailable?: boolean;
};
export type ChangeTerminalDevicesRequest = {
  tonometerName: string;
  alcotesterName: string;
  thermometerName: string;
};
export type ThermohygrometerDataResponse = {
  id: number;
  terminalId: number;
  scanDate: string;
  examId?: number | null;
  temperature: number;
  moisture: number;
};
export type AddThermohygrometerDataRequest = {
  examId?: number | null;
  temperature: number;
  moisture: number;
};
export type UserDto = {
  id: number;
  userName?: string | null;
  status: UserStatusEnum;
};
export type UserDtoPagedListModel = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: UserDto[] | null;
};
export type UserDtoPagedListModelRead = {
  page?: number | null;
  offset?: number | null;
  totalResults?: number | null;
  models?: UserDto[] | null;
  totalPages?: number | null;
  hasNextPage?: boolean | null;
  hasPreviousPage?: boolean | null;
};
export type ImportUsersSummary = {
  totalProcessed?: number;
  successfullyCreated?: number;
  failed?: number;
};
export type ImportUsersFailedRow = {
  rowNumber?: number;
  login?: string | null;
  error?: string | null;
};
export type ImportUsersFailed = {
  reportUrl?: string | null;
  rows?: ImportUsersFailedRow[] | null;
};
export type ImportUsersResponse = {
  isSuccess?: boolean;
  message?: string | null;
  summary?: ImportUsersSummary;
  failed?: ImportUsersFailed;
};
export type ChangePasswordRequest = {
  oldPassword: string;
  newPassword: string;
};
export type ResetPasswordRequest = {
  newPassword: string;
};
export type WorkPlaceModel = {
  id: number;
  doctorId: number;
  hospitalName: string;
  phone?: string | null;
  addressId: number;
  position?: string | null;
  startDate: string;
  endDate: string;
};
export type AddWorkPlaceRequest = {
  hospitalName: string;
  phone?: string | null;
  addressId: number;
  position?: string | null;
  startDate: string;
  endDate: string;
};
export type ChangeWorkPlaceRequest = {
  hospitalName: string;
  phone?: string | null;
  addressId: number;
  position?: string | null;
  startDate: string;
  endDate: string;
};
export const {
  usePostV2AdminsMutation,
  useGetV2ExamsByExamIdAlcoTestProcsAndIdQuery,
  useLazyGetV2ExamsByExamIdAlcoTestProcsAndIdQuery,
  usePostV2ExamsByExamIdAlcoTestProcsStartMutation,
  usePostV2ExamsByExamIdAlcoTestProcsMutation,
  useGetV2QuizesByQuizIdAnswersQuery,
  useLazyGetV2QuizesByQuizIdAnswersQuery,
  useGetV2QuizesByQuizIdAnswersAndIdQuery,
  useLazyGetV2QuizesByQuizIdAnswersAndIdQuery,
  usePostV2QuizesByQuizIdAnswersListMutation,
  useGetV2TerminalsByTerminalIdApiKeysQuery,
  useLazyGetV2TerminalsByTerminalIdApiKeysQuery,
  usePostV2TerminalsByTerminalIdApiKeysMutation,
  usePostAuthenticationLoginMutation,
  usePostAuthenticationRefreshTokenMutation,
  useGetV2ExamsByExamIdBloodPressProcsAndIdQuery,
  useLazyGetV2ExamsByExamIdBloodPressProcsAndIdQuery,
  usePostV2ExamsByExamIdBloodPressProcsStartMutation,
  usePostV2ExamsByExamIdBloodPressProcsMutation,
  useGetV2PersonsByPersonIdCertificatesQuery,
  useLazyGetV2PersonsByPersonIdCertificatesQuery,
  usePostV2PersonsByPersonIdCertificatesMutation,
  usePutV2PersonsByPersonIdCertificatesAndIdStatusMutation,
  useGetV2ExamsByExamIdConclusionsQuery,
  useLazyGetV2ExamsByExamIdConclusionsQuery,
  usePostV2ExamsByExamIdConclusionsMutation,
  useGetV2ExamsConclusionsStatisticsQuery,
  useLazyGetV2ExamsConclusionsStatisticsQuery,
  useGetV2PatientsByPatientIdExamsConclusionsQuery,
  useLazyGetV2PatientsByPatientIdExamsConclusionsQuery,
  useGetV2ConclusionsByIdStickerQuery,
  useLazyGetV2ConclusionsByIdStickerQuery,
  usePostV2ExamsByExamIdConclusionsAndIdGenerateDocumentMutation,
  usePostV2ExamsByExamIdConclusionsAndIdSignMutation,
  usePostV2DirectorsMutation,
  useGetV2PersonsByPersonIdDoctorsQuery,
  useLazyGetV2PersonsByPersonIdDoctorsQuery,
  useGetV2MedOrganizationsByMedOrganizationIdDoctorsQuery,
  useLazyGetV2MedOrganizationsByMedOrganizationIdDoctorsQuery,
  usePostV2DoctorsMutation,
  usePutV2PersonsByPersonIdDoctorsAndIdMutation,
  usePutV2PatientsByPatientIdDriverLicensesAndIdMutation,
  useDeleteV2PatientsByPatientIdDriverLicensesAndIdMutation,
  useGetV2DoctorsByDoctorIdEducationsQuery,
  useLazyGetV2DoctorsByDoctorIdEducationsQuery,
  usePostV2DoctorsByDoctorIdEducationsMutation,
  usePutV2DoctorsByDoctorIdEducationsAndIdMutation,
  useDeleteV2DoctorsByDoctorIdEducationsAndIdMutation,
  usePostV2ExamsByExamIdMediasProcedurePhotoMutation,
  usePostV2ExamsByExamIdMediasVideoMutation,
  useGetV2ExamsQuery,
  useLazyGetV2ExamsQuery,
  useGetV2ExamsByIdQuery,
  useLazyGetV2ExamsByIdQuery,
  useGetV2PatientsByPatientIdExamsQuery,
  useLazyGetV2PatientsByPatientIdExamsQuery,
  useGetV2PatientsByPatientIdExamsAvailableTypesQuery,
  useLazyGetV2PatientsByPatientIdExamsAvailableTypesQuery,
  usePostV2ExamsStartMutation,
  usePostV2ExamsByIdBreakMutation,
  usePutV2ExamsByIdStatusMutation,
  usePostV2ExternalDoctorsMutation,
  useGetV2FaceVerificationResultsEventsQuery,
  useLazyGetV2FaceVerificationResultsEventsQuery,
  useGetV2FilesDownloadUrlQuery,
  useLazyGetV2FilesDownloadUrlQuery,
  usePostV2FilesOtherUploadMutation,
  usePostV2LicenseDataMutation,
  usePostV2TerminalsByTerminalIdLuxmeterDataMutation,
  useGetV2TerminalsByTerminalIdLuxmeterDataQuery,
  useLazyGetV2TerminalsByTerminalIdLuxmeterDataQuery,
  useGetV2TerminalsByTerminalIdLuxmeterDataClosestQuery,
  useLazyGetV2TerminalsByTerminalIdLuxmeterDataClosestQuery,
  useGetV2MedOrganizationsQuery,
  useLazyGetV2MedOrganizationsQuery,
  usePostV2MedOrganizationsMutation,
  useGetV2MedOrganizationsByIdQuery,
  useLazyGetV2MedOrganizationsByIdQuery,
  usePutV2MedOrganizationsByIdMutation,
  useDeleteV2MedOrganizationsByIdMutation,
  useGetV2OrganizationsByOrganizationIdMedOrganizationsQuery,
  useLazyGetV2OrganizationsByOrganizationIdMedOrganizationsQuery,
  useGetV2ExamsByExamIdMindTestsAndIdQuery,
  useLazyGetV2ExamsByExamIdMindTestsAndIdQuery,
  usePostV2ExamsByExamIdMindTestsMutation,
  useGetV2PersonsByPersonIdNotificationsQuery,
  useLazyGetV2PersonsByPersonIdNotificationsQuery,
  useDeleteV2PersonsByPersonIdNotificationsMutation,
  usePutV2PersonsByPersonIdNotificationsAndIdReadMutation,
  usePutV2PersonsByPersonIdNotificationsReadMutation,
  useDeleteV2PersonsByPersonIdNotificationsAndIdMutation,
  usePutV2PersonsByPersonIdNotificationsTokenMutation,
  useGetV2OrganizationsQuery,
  useLazyGetV2OrganizationsQuery,
  usePostV2OrganizationsMutation,
  useGetV2OrganizationsByIdQuery,
  useLazyGetV2OrganizationsByIdQuery,
  usePutV2OrganizationsByIdMutation,
  useDeleteV2OrganizationsByIdMutation,
  useGetV2MedOrganizationsByMedOrganizationIdOrganizationsQuery,
  useLazyGetV2MedOrganizationsByMedOrganizationIdOrganizationsQuery,
  usePostV2OrganizationsByIdMedOrganizationsAndMedOrganizationIdMutation,
  useDeleteV2OrganizationsByIdMedOrganizationsAndMedOrganizationIdMutation,
  useGetV2PersonsByPersonalNumberByPersonalNumberPatientsQuery,
  useLazyGetV2PersonsByPersonalNumberByPersonalNumberPatientsQuery,
  useGetV2PersonsBySnilsBySnilsPatientsQuery,
  useLazyGetV2PersonsBySnilsBySnilsPatientsQuery,
  useGetV2PersonsByPersonIdPatientsQuery,
  useLazyGetV2PersonsByPersonIdPatientsQuery,
  useGetV2OrganizationsByOrganizationIdPatientsQuery,
  useLazyGetV2OrganizationsByOrganizationIdPatientsQuery,
  useGetV2PatientsByExternalIdByExternalIdQuery,
  useLazyGetV2PatientsByExternalIdByExternalIdQuery,
  usePostV2PatientsMutation,
  usePutV2PersonsByPersonIdPatientsAndIdMutation,
  usePutV2PersonsByPersonIdPatientsAndIdActivityMutation,
  useGetV2PersonsByPersonIdPhotosQuery,
  useLazyGetV2PersonsByPersonIdPhotosQuery,
  usePostV2PersonsByPersonIdPhotosMutation,
  usePutV2PersonsByPersonIdPhotosAndIdMutation,
  useDeleteV2PersonsByPersonIdPhotosAndIdMutation,
  usePutV2PersonsByPersonIdPhotosStatusMutation,
  useGetV2PersonsQuery,
  useLazyGetV2PersonsQuery,
  useGetV2PersonsByIdQuery,
  useLazyGetV2PersonsByIdQuery,
  usePutV2PersonsByIdMutation,
  useGetV2PersonsPersonalNumberByPersonalNumberIsUniqueQuery,
  useLazyGetV2PersonsPersonalNumberByPersonalNumberIsUniqueQuery,
  useGetV2PersonsSnilsBySnilsIsUniqueQuery,
  useLazyGetV2PersonsSnilsBySnilsIsUniqueQuery,
  useGetV2PostTripJournalsQuery,
  useLazyGetV2PostTripJournalsQuery,
  useGetV2PostTripJournalsByIdQuery,
  useLazyGetV2PostTripJournalsByIdQuery,
  useGetV2PostTripJournalsDatesQuery,
  useLazyGetV2PostTripJournalsDatesQuery,
  useGetV2PostTripJournalsDocumentQuery,
  useLazyGetV2PostTripJournalsDocumentQuery,
  usePostV2PostTripJournalsByIdSignMutation,
  usePostV2ExamsByExamIdPostTripJournalsSignMutation,
  useGetV2ExamsByExamIdPostTripJournalsHashQuery,
  useLazyGetV2ExamsByExamIdPostTripJournalsHashQuery,
  useGetV2PostTripJournalsByIdHashQuery,
  useLazyGetV2PostTripJournalsByIdHashQuery,
  useGetV2PreTripJournalsQuery,
  useLazyGetV2PreTripJournalsQuery,
  useGetV2PreTripJournalsByIdQuery,
  useLazyGetV2PreTripJournalsByIdQuery,
  useGetV2PreTripJournalsDatesQuery,
  useLazyGetV2PreTripJournalsDatesQuery,
  useGetV2PreTripJournalsDocumentQuery,
  useLazyGetV2PreTripJournalsDocumentQuery,
  usePostV2PreTripJournalsByIdSignMutation,
  usePostV2ExamsByExamIdPreTripJournalsSignMutation,
  useGetV2ExamsByExamIdPreTripJournalsHashQuery,
  useLazyGetV2ExamsByExamIdPreTripJournalsHashQuery,
  useGetV2PreTripJournalsByIdHashQuery,
  useLazyGetV2PreTripJournalsByIdHashQuery,
  useGetV2ProcedureDevicesQuery,
  useLazyGetV2ProcedureDevicesQuery,
  useGetV2ProcedureDevicesByNameByNameQuery,
  useLazyGetV2ProcedureDevicesByNameByNameQuery,
  usePutV2ProcedureDevicesByIdMutation,
  useGetV2QuestionsQuery,
  useLazyGetV2QuestionsQuery,
  usePostV2ExamsByExamIdQuizesMutation,
  useGetV2ReasonsQuery,
  useLazyGetV2ReasonsQuery,
  useGetV2ReasonsByIdQuery,
  useLazyGetV2ReasonsByIdQuery,
  useGetV2PatientsByPatientIdReferenceIndicatorsQuery,
  useLazyGetV2PatientsByPatientIdReferenceIndicatorsQuery,
  usePostV2PatientsByPatientIdReferenceIndicatorsMutation,
  usePutV2PatientsByPatientIdReferenceIndicatorsAndIdMutation,
  useDeleteV2PatientsByPatientIdReferenceIndicatorsAndIdMutation,
  useGetV2ReportsGeneratePivotTableQuery,
  useLazyGetV2ReportsGeneratePivotTableQuery,
  useGetV2ReportsGenerateExamReportQuery,
  useLazyGetV2ReportsGenerateExamReportQuery,
  useGetV2RolesQuery,
  useLazyGetV2RolesQuery,
  useGetV2UsersByUserIdRolesQuery,
  useLazyGetV2UsersByUserIdRolesQuery,
  usePostV2UsersByUserIdRolesAdminMutation,
  usePostV2UsersByUserIdRolesDirectorMutation,
  usePostV2UsersByUserIdRolesDoctorMutation,
  useDeleteV2UsersByUserIdRolesAndIdMutation,
  useGetV2ExamsSetSseConnectionQuery,
  useLazyGetV2ExamsSetSseConnectionQuery,
  useGetV2SpecialitiesQuery,
  useLazyGetV2SpecialitiesQuery,
  useGetV2ExamsByExamIdSpeechTestsAndIdQuery,
  useLazyGetV2ExamsByExamIdSpeechTestsAndIdQuery,
  usePostV2ExamsByExamIdSpeechTestsMutation,
  useGetSystemRabbitInfoQuery,
  useLazyGetSystemRabbitInfoQuery,
  useGetSystemApiVersionsQuery,
  useLazyGetSystemApiVersionsQuery,
  useGetSystemClientsVersionsQuery,
  useLazyGetSystemClientsVersionsQuery,
  useGetV2ExamsByExamIdTemperatureProcsAndIdQuery,
  useLazyGetV2ExamsByExamIdTemperatureProcsAndIdQuery,
  usePostV2ExamsByExamIdTemperatureProcsStartMutation,
  usePostV2ExamsByExamIdTemperatureProcsMutation,
  useGetV2TerminalsByTerminalIdCaseOpeningsQuery,
  useLazyGetV2TerminalsByTerminalIdCaseOpeningsQuery,
  usePutV2TerminalsByTerminalIdCaseOpeningsIncrementMutation,
  usePostV2TerminalsByTerminalIdChecksumsMutation,
  usePutV2TerminalsByTerminalIdChecksumsAndIdMutation,
  useDeleteV2TerminalsByTerminalIdChecksumsAndIdMutation,
  useGetV2TerminalsByTerminalIdEventsQuery,
  useLazyGetV2TerminalsByTerminalIdEventsQuery,
  usePostV2TerminalsByTerminalIdEventsMutation,
  useGetV2TerminalsQuery,
  useLazyGetV2TerminalsQuery,
  usePostV2TerminalsMutation,
  useGetV2TerminalsByIdQuery,
  useLazyGetV2TerminalsByIdQuery,
  usePutV2TerminalsByIdMutation,
  useGetV2TerminalsBySerialNumberBySerialNumberQuery,
  useLazyGetV2TerminalsBySerialNumberBySerialNumberQuery,
  useGetV2TerminalsAvailabilityQuery,
  useLazyGetV2TerminalsAvailabilityQuery,
  usePostV2TerminalsByIdRebootMutation,
  usePutV2TerminalsByIdVerificationDateMutation,
  usePutV2TerminalsByIdStatusMutation,
  usePutV2TerminalsByIdVersionMutation,
  usePutV2TerminalsByIdDevicesMutation,
  usePutV2TerminalsByIdTypeMutation,
  useGetV2TerminalsByTerminalIdThermohygrometerDataQuery,
  useLazyGetV2TerminalsByTerminalIdThermohygrometerDataQuery,
  usePostV2TerminalsByTerminalIdThermohygrometerDataMutation,
  useGetV2TerminalsByTerminalIdThermohygrometerDataClosestQuery,
  useLazyGetV2TerminalsByTerminalIdThermohygrometerDataClosestQuery,
  useGetV2UsersQuery,
  useLazyGetV2UsersQuery,
  useGetV2UsersByIdQuery,
  useLazyGetV2UsersByIdQuery,
  useGetV2UsersByNameIsUniqueQuery,
  useLazyGetV2UsersByNameIsUniqueQuery,
  usePostV2UsersImportMutation,
  usePutV2UsersByIdStatusMutation,
  usePutV2UsersByIdNameMutation,
  usePutV2UsersByNamePasswordMutation,
  usePutV2UsersByNameResetPasswordMutation,
  useGetV2DoctorsByDoctorIdWorkPlacesQuery,
  useLazyGetV2DoctorsByDoctorIdWorkPlacesQuery,
  usePostV2DoctorsByDoctorIdWorkPlacesMutation,
  useGetV2DoctorsByDoctorIdWorkPlacesAndIdQuery,
  useLazyGetV2DoctorsByDoctorIdWorkPlacesAndIdQuery,
  usePutV2DoctorsByDoctorIdWorkPlacesAndIdMutation,
  useDeleteV2DoctorsByDoctorIdWorkPlacesAndIdMutation,
} = injectedRtkApi;
